webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(586);
	
	var _reactRedux = __webpack_require__(135);
	
	var _rpGuiGuide = __webpack_require__(237);
	
	var _rpGuiGuide2 = _interopRequireDefault(_rpGuiGuide);
	
	var _rpPopup = __webpack_require__(636);
	
	var _rpPopup2 = _interopRequireDefault(_rpPopup);
	
	var _rpCookie = __webpack_require__(70);
	
	var _rpUrlNavigationPrefs = __webpack_require__(641);
	
	var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);
	
	var _rpAdvertising = __webpack_require__(378);
	
	var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);
	
	var _rpNavigation = __webpack_require__(388);
	
	__webpack_require__(1121);
	
	__webpack_require__(1120);
	
	__webpack_require__(1123);
	
	__webpack_require__(1122);
	
	var _App = __webpack_require__(678);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _configureStore = __webpack_require__(712);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	__webpack_require__(1125);
	
	var _analyticsPage = __webpack_require__(711);
	
	var _analyticsPage2 = _interopRequireDefault(_analyticsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _analyticsPage2.default)();
	/**
	 * Clean-up legacy cookies
	 */
	(0, _rpCookie.cleanLegacy)();
	/**
	 * Initialize gui-guide scripts
	 */
	(0, _rpGuiGuide2.default)({
	  svg: { polyfill: true }
	});
	/**
	 * Initialize popup component
	 */
	(0, _rpPopup2.default)();
	/**
	 * Initialize navigation cards preferences
	 */
	(0, _rpUrlNavigationPrefs2.default)();
	
	var homepageContainer = document.getElementById('homepageId');
	
	/**
	 * Render react application to root element
	 *
	 * Renders only for Homepage and Content Hub routes.
	 * Inits Ads component only for cookie-policy route.
	 */
	if (homepageContainer) {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_App2.default, null)
	  ), homepageContainer);
	} else {
	  (0, _rpAdvertising2.default)();
	}
	/**
	 * show appPromo banner after page content is loaded
	 */
	_rpNavigation.appPromo.init();

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(735), __esModule: true };

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(720);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(71);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(401);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(401);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getRaceInfoKey = function getRaceInfoKey(_ref) {
	    var bookmaker = _ref.bookmaker,
	        raceTime = _ref.raceTime,
	        raceDate = _ref.raceDate,
	        courseName = _ref.courseName;
	
	    if (!(raceTime && raceDate && courseName && bookmaker)) {
	        // eslint-disable-next-line no-console
	        console.error('no required info data in: getRaceInfoKey');
	    }
	    return (raceDate + '/' + raceTime + '/' + courseName + '/' + bookmaker).toUpperCase();
	};
	
	var PricesStateStore = function () {
	    function PricesStateStore() {
	        _classCallCheck(this, PricesStateStore);
	
	        this.showDecimalPrices = false;
	        this.raceInfo = {};
	        this.currentBookmakerName = null;
	    }
	
	    _createClass(PricesStateStore, [{
	        key: 'setPriceViewType',
	        value: function setPriceViewType(_ref2) {
	            var showDecimal = _ref2.showDecimal;
	
	            this.showDecimalPrices = showDecimal;
	        }
	    }, {
	        key: 'isDecimalPrice',
	        value: function isDecimalPrice() {
	            return this.showDecimalPrices;
	        }
	    }, {
	        key: 'setCurrentBookmaker',
	        value: function setCurrentBookmaker(bookmakerName) {
	            this.currentBookmakerName = bookmakerName;
	        }
	    }, {
	        key: 'getCurrentBookmaker',
	        value: function getCurrentBookmaker() {
	            return this.currentBookmakerName;
	        }
	    }, {
	        key: 'updateRaceInfo',
	        value: function updateRaceInfo(_ref3) {
	            var bookmaker = _ref3.bookmaker,
	                raceTime = _ref3.raceTime,
	                raceDate = _ref3.raceDate,
	                courseName = _ref3.courseName,
	                suspendState = _ref3.suspendState,
	                winOdds = _ref3.winOdds,
	                placeWinner = _ref3.placeWinner,
	                isBog = _ref3.isBog;
	
	            var statusKey = getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName });
	
	            this.raceInfo[statusKey] = { suspendState: suspendState, winOdds: winOdds, placeWinner: placeWinner, isBog: isBog };
	        }
	    }, {
	        key: 'getRaceInfo',
	        value: function getRaceInfo(_ref4) {
	            var bookmaker = _ref4.bookmaker,
	                raceTime = _ref4.raceTime,
	                raceDate = _ref4.raceDate,
	                courseName = _ref4.courseName;
	
	            return this.raceInfo[getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName })];
	        }
	    }]);
	
	    return PricesStateStore;
	}();
	// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
	/* eslint-disable import/prefer-default-export */
	
	
	var pricesStateStore = exports.pricesStateStore = new PricesStateStore();

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.diffusionServiceUtils = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _DIFFUSION = __webpack_require__(238);
	
	var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);
	
	var _DiffusionFeedHelper = __webpack_require__(1526);
	
	var _DiffusionFeedHelper2 = _interopRequireDefault(_DiffusionFeedHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTopicRaceType() {
	    return 'HORSES';
	}
	
	function getTopicInfoType() {
	    return '#INFO';
	}
	
	function getTopicMarketType(type) {
	    return type || 'WIN';
	}
	
	function getElementDataAttribute(attribute, element) {
	    return (0, _jquery2.default)(element).closest('[' + attribute + ']').attr(attribute);
	}
	
	function getTopicRaceDate(element) {
	    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, element);
	}
	
	function getTopicCourseName(element) {
	    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, element);
	}
	
	function getTopicRaceTime(element) {
	    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, element);
	}
	
	function getTopicHorseName(element) {
	    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, element);
	}
	
	function getTopicBookmaker(element) {
	    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER, element);
	}
	
	function getElementDiffusionData(element) {
	    return {
	        horseName: getTopicHorseName(element),
	        courseName: getTopicCourseName(element),
	        raceTime: getTopicRaceTime(element),
	        raceDate: getTopicRaceDate(element)
	    };
	}
	
	function createInfoTopic(_ref) {
	    var raceDate = _ref.raceDate,
	        courseName = _ref.courseName,
	        raceTime = _ref.raceTime,
	        bookmaker = _ref.bookmaker;
	
	    if (!raceDate || !courseName || !raceTime || !bookmaker) {
	        // eslint-disable-next-line no-console
	        console.error('info topic not created', raceDate, courseName, raceTime, bookmaker);
	        return null;
	    }
	
	    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), getTopicInfoType(), _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];
	
	    return topicArray.join('/');
	}
	
	function createPriceTopic(_ref2) {
	    var raceDate = _ref2.raceDate,
	        courseName = _ref2.courseName,
	        raceTime = _ref2.raceTime,
	        horseName = _ref2.horseName,
	        bookmaker = _ref2.bookmaker;
	
	    if (!raceDate || !courseName || !raceTime || !horseName || !bookmaker) {
	        // eslint-disable-next-line no-console
	        console.error('price topic not created', raceDate, courseName, raceTime, horseName, bookmaker);
	        return null;
	    }
	
	    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), horseName, _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];
	
	    return topicArray.join('/');
	}
	
	function parseDiffusionTopic(topic) {
	    var topicArray = topic.split('/');
	    return {
	        raceType: topicArray[0],
	        raceDate: topicArray[1],
	        courseName: topicArray[2],
	        raceTime: topicArray[3],
	        marketType: topicArray[4],
	        infoType: topicArray[5],
	        bookmaker: topicArray[6]
	    };
	}
	
	function parseInfoTopicData(WebClientMessage) {
	    var _WebClientMessage$get = WebClientMessage.getFields(0),
	        _WebClientMessage$get2 = _slicedToArray(_WebClientMessage$get, 4),
	        eachwayTerms = _WebClientMessage$get2[0],
	        isBog = _WebClientMessage$get2[1],
	        suspendState = _WebClientMessage$get2[2],
	        orderBy = _WebClientMessage$get2[3];
	
	    var isWinOnly = eachwayTerms === '1/1|1-1';
	
	    var _eachwayTerms$split = eachwayTerms.split('|'),
	        _eachwayTerms$split2 = _slicedToArray(_eachwayTerms$split, 2),
	        winOdds = _eachwayTerms$split2[0],
	        placeWinner = _eachwayTerms$split2[1];
	
	    var topic = WebClientMessage.getTopic();
	
	    var _parseDiffusionTopic = parseDiffusionTopic(topic),
	        bookmaker = _parseDiffusionTopic.bookmaker,
	        courseName = _parseDiffusionTopic.courseName,
	        raceDate = _parseDiffusionTopic.raceDate,
	        raceTime = _parseDiffusionTopic.raceTime;
	
	    return {
	        raceDate: raceDate,
	        courseName: courseName,
	        raceTime: raceTime,
	        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
	        winOdds: winOdds,
	        placeWinner: placeWinner,
	        isWinOnly: isWinOnly,
	        isBog: isBog,
	        suspendState: suspendState,
	        orderBy: orderBy
	    };
	}
	
	function parsePriceTopicData(WebClientMessage) {
	    var dataFields = WebClientMessage.getFields(0);
	    var topic = WebClientMessage.getTopic();
	
	    var _parseDiffusionTopic2 = parseDiffusionTopic(topic),
	        horseName = _parseDiffusionTopic2.infoType,
	        bookmaker = _parseDiffusionTopic2.bookmaker,
	        courseName = _parseDiffusionTopic2.courseName,
	        raceDate = _parseDiffusionTopic2.raceDate,
	        raceTime = _parseDiffusionTopic2.raceTime;
	
	    var historyPrices = {
	        fractional: dataFields.slice(9, 14),
	        decimal: dataFields.slice(14, 19)
	    };
	
	    return {
	        horseName: horseName,
	        raceDate: raceDate,
	        courseName: courseName,
	        raceTime: raceTime,
	        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
	        historyPrices: historyPrices,
	        outcomersId: dataFields[1],
	        eventId: dataFields[4],
	        meetingId: dataFields[5],
	        status: dataFields[6],
	        fractionalPrice: dataFields[7],
	        decimalPrice: dataFields[8],
	        historyPrice: dataFields[14]
	    };
	}
	
	function getDisplayedPriceValue(renderConfig) {
	    var result = void 0;
	    var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
	    var raceSuspendState = raceInfo && raceInfo.suspendState;
	    var isHorseSuspended = [renderConfig.status, raceSuspendState].includes('H');
	
	    if (isHorseSuspended) {
	        return '-';
	    }
	    if (!renderConfig.decimalPrice && !renderConfig.fractionalPrice) {
	        return '';
	    }
	    if (!renderConfig.decimalPrice) {
	        return 'SP';
	    }
	    if (_PricesStateStore.pricesStateStore.isDecimalPrice()) {
	        result = Math.floor(parseFloat(renderConfig.decimalPrice) * 100) / 100;
	    } else {
	        result = renderConfig.fractionalPrice;
	    }
	    if (renderConfig.bookmaker === 'TOTE') {
	        result = parseFloat(result).toFixed(2);
	    }
	    return result;
	}
	
	function getPriceContainer(horseData) {
	    return (0, _jquery2.default)('[' + _DIFFUSION2.default.DATA.INPUT.HORSE_NAME + ']').toArray().filter(function (element) {
	        var _getElementDiffusionD = getElementDiffusionData(element),
	            courseName = _getElementDiffusionD.courseName,
	            raceTime = _getElementDiffusionD.raceTime,
	            raceDate = _getElementDiffusionD.raceDate,
	            horseName = _getElementDiffusionD.horseName;
	
	        return horseName.toUpperCase() === horseData.horseName.toUpperCase() && raceDate === horseData.raceDate && raceTime === horseData.raceTime && courseName === horseData.courseName;
	    });
	}
	// TODO: export by default or export all methods separately (JIRA: PC-4559)
	/* eslint-disable import/prefer-default-export */
	var diffusionServiceUtils = exports.diffusionServiceUtils = {
	    getTopicRaceType: getTopicRaceType,
	    getTopicInfoType: getTopicInfoType,
	    getTopicMarketType: getTopicMarketType,
	    getTopicRaceDate: getTopicRaceDate,
	    getTopicCourseName: getTopicCourseName,
	    getTopicRaceTime: getTopicRaceTime,
	    getTopicHorseName: getTopicHorseName,
	    getTopicBookmaker: getTopicBookmaker,
	    getElementDataAttribute: getElementDataAttribute,
	    getElementDiffusionData: getElementDiffusionData,
	    createInfoTopic: createInfoTopic,
	    createPriceTopic: createPriceTopic,
	    parseDiffusionTopic: parseDiffusionTopic,
	    parseInfoTopicData: parseInfoTopicData,
	    parsePriceTopicData: parsePriceTopicData,
	    getDisplayedPriceValue: getDisplayedPriceValue,
	    getPriceContainer: getPriceContainer
	};

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    DATA: {
	        INPUT: {
	            HORSE_NAME: 'data-diffusion-horsename',
	            COURSE_NAME: 'data-diffusion-coursename',
	            RACE_TIME: 'data-diffusion-racetime',
	            RACE_DATE: 'data-diffusion-racedate',
	            BOOKMAKER: 'data-diffusion-bookmaker'
	        },
	        OUTPUT: {
	            OUTCOMERS_ID: 'data-diffusion-outcomers-id',
	            FRACTIONAL: 'data-diffusion-fractional',
	            DECIMAL: 'data-diffusion-decimal',
	            HISTORY: 'data-diffusion-history',
	            STATUS: 'data-diffusion-status',
	            EVENT_ID: 'data-diffusion-event-id',
	            MEETING_ID: 'data-diffusion-meeting-id',
	            NEXT_PRICE: 'data-diffusion-next-price'
	        }
	    }
	};

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Advertisement = __webpack_require__(673);
	
	var _Advertisement2 = _interopRequireDefault(_Advertisement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Advertisement module exports
	 */
	exports.default = _Advertisement2.default; /**
	                                            * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                            */

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var contentHubTitles = {
	    'cheltenham-festival': {
	        title: 'Cheltenham festival',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'the-derby': {
	        title: 'The Derby',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'grand-national': {
	        title: 'Grand National',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'champions-day': {
	        title: 'Champions Day',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'royal-ascot': {
	        title: 'Royal Ascot',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'glorious-goodwood': {
	        title: 'Glorious Goodwood',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'breeders-cup': {
	        title: 'Breeders\' Cup',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    '1000-guineas': {
	        title: '1,000 Guineas',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    '2000-guineas': {
	        title: '2,000 Guineas',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    'melbourne-cup': {
	        title: 'Melbourne Cup',
	        showRaceDaylive: true,
	        showRegPanel: true
	    },
	    pools: {
	        title: 'Tote Pools',
	        showRaceDaylive: false,
	        showRegPanel: false
	    },
	    'ten-to-follow': {
	        title: 'Ten To Follow Competition',
	        showRaceDaylive: false,
	        showRegPanel: false
	    }
	};
	
	var getNewsTitle = exports.getNewsTitle = function getNewsTitle() {
	    var routeName = window.location.pathname.replace('/', '').replace('/', '');
	
	    if (contentHubTitles[routeName]) {
	        return contentHubTitles[routeName].title;
	    }
	
	    return '';
	};
	
	var isContentHubPage = exports.isContentHubPage = function isContentHubPage() {
	    return !!getNewsTitle();
	};
	
	var checkForRacedayLive = exports.checkForRacedayLive = function checkForRacedayLive() {
	    var routeName = window.location.pathname.replace('/', '').replace('/', '');
	
	    if (contentHubTitles[routeName]) {
	        return contentHubTitles[routeName].showRaceDaylive;
	    }
	
	    return true;
	};
	
	var checkForRegPanel = exports.checkForRegPanel = function checkForRegPanel() {
	    var routeName = window.location.pathname.replace('/', '').replace('/', '');
	
	    if (contentHubTitles[routeName]) {
	        return contentHubTitles[routeName].showRegPanel;
	    }
	
	    return true;
	};
	
	exports.default = { isContentHubPage: isContentHubPage, getNewsTitle: getNewsTitle, checkForRacedayLive: checkForRacedayLive, checkForRegPanel: checkForRegPanel };

/***/ }),

/***/ 262:
[1659, 41, 27, 145, 263, 83],

/***/ 263:
[1660, 42],

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BookmakerRegPanel = undefined;
	
	var _BookmakerRegPanel = __webpack_require__(679);
	
	var _BookmakerRegPanel2 = _interopRequireDefault(_BookmakerRegPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Bookmakers module exports
	 */
	exports.BookmakerRegPanel = _BookmakerRegPanel.BookmakerRegPanel;
	exports.default = _BookmakerRegPanel2.default; /**
	                                                * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                                */

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(723);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(722);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),

/***/ 406:
[1654, 147, 180, 97, 261, 95, 403, 81],

/***/ 407:
[1656, 409, 253],

/***/ 623:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.pricesProvider = exports.PRICE_HANDLER_EVENTS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jsCookie = __webpack_require__(162);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _rpDiffusionConnector = __webpack_require__(212);
	
	var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _HorsesListStore = __webpack_require__(639);
	
	var _PubSub2 = __webpack_require__(1528);
	
	var _PubSub3 = _interopRequireDefault(_PubSub2);
	
	var _DiffusionSubscriber = __webpack_require__(1527);
	
	var _DiffusionSubscriber2 = _interopRequireDefault(_DiffusionSubscriber);
	
	var _EVENTS = __webpack_require__(638);
	
	var _EVENTS2 = _interopRequireDefault(_EVENTS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRICE_HANDLER_EVENTS = exports.PRICE_HANDLER_EVENTS = {
	    PRICE_RECEIVED: 'PRICE_RECEIVED',
	    PRICES_WILL_BE_UPDATED: 'PRICES_WILL_BE_UPDATED',
	    PRICES_SETTINGS_CHANGED: 'PRICES_SETTINGS_CHANGED',
	    RACE_INFO_RECEIVED: 'RACE_INFO_RECEIVED'
	};
	
	var PricesProvider = function (_PubSub) {
	    _inherits(PricesProvider, _PubSub);
	
	    function PricesProvider() {
	        _classCallCheck(this, PricesProvider);
	
	        var _this = _possibleConstructorReturn(this, (PricesProvider.__proto__ || Object.getPrototypeOf(PricesProvider)).call(this));
	
	        _this.config = {
	            session: {
	                onDataFunction: _this.onDataReceive.bind(_this),
	                onCallbackFunction: _this.onConnectionStatusChange.bind(_this)
	            }
	        };
	        return _this;
	    }
	
	    _createClass(PricesProvider, [{
	        key: 'init',
	        value: function init(bookmakerName) {
	            _PricesStateStore.pricesStateStore.setCurrentBookmaker(bookmakerName);
	            if (_jsCookie2.default.get('customizeSettings')) {
	                this.setPriceViewType();
	            }
	            this.session = new _rpDiffusionConnector2.default(this.config.session);
	            this.subscriber = new _DiffusionSubscriber2.default(this.session);
	            this.subscriber.run();
	            this.bindEvents();
	            _HorsesListStore.horsesListStore.updateHorsesData();
	            // TODO: move it out of provider (JIRA: PC-4559)
	            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmakerName);
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            (0, _jquery2.default)(document).on(_EVENTS2.default.BOOKMAKER_CHANGED, this.onBookmakerChanged.bind(this));
	            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicPricesUpdated.bind(this));
	            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onHorsesListChanged.bind(this));
	            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
	        }
	
	        /* eslint-disable class-methods-use-this */
	
	    }, {
	        key: 'setPriceViewType',
	        value: function setPriceViewType() {
	            var showDecimal = JSON.parse(_jsCookie2.default.get('customizeSettings')).decimalOdds;
	            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
	                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
	            }
	        }
	        /* eslint-enable class-methods-use-this */
	
	    }, {
	        key: 'onBookmakerChanged',
	        value: function onBookmakerChanged(event, newBookmakerName) {
	            var horsesList = _HorsesListStore.horsesListStore.getHorsesList();
	
	            this.unsubscribeAll();
	            _PricesStateStore.pricesStateStore.setCurrentBookmaker(newBookmakerName);
	            this.publish(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED);
	            this.subscribeForPrices(horsesList, newBookmakerName);
	        }
	    }, {
	        key: 'onDynamicPricesUpdated',
	        value: function onDynamicPricesUpdated() {
	            var newHorsesData = _HorsesListStore.horsesListStore.updateHorsesData();
	            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	
	            this.subscribeForPrices(newHorsesData, bookmaker);
	        }
	    }, {
	        key: 'onHorsesListChanged',
	        value: function onHorsesListChanged() {
	            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	
	            this.unsubscribeAll();
	            _HorsesListStore.horsesListStore.updateHorsesData();
	            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmaker);
	        }
	    }, {
	        key: 'onUserSettingsChanged',
	        value: function onUserSettingsChanged(event, userSettings) {
	            var showDecimal = userSettings.decimalOdds;
	
	            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
	                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
	                this.publish(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, { showDecimal: showDecimal });
	            }
	        }
	    }, {
	        key: 'unsubscribeAll',
	        value: function unsubscribeAll() {
	            this.subscriber.unsubscribeAll();
	        }
	    }, {
	        key: 'subscribeForPrices',
	        value: function subscribeForPrices(horsesList, bookmaker) {
	            if (!bookmaker) {
	                return;
	            }
	
	            var topics = horsesList.filter(function (horseData) {
	                return horseData;
	            }).map(function (horseData) {
	                var courseName = horseData.courseName,
	                    raceTime = horseData.raceTime,
	                    raceDate = horseData.raceDate,
	                    horseName = horseData.horseName;
	
	                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic({
	                    courseName: courseName,
	                    raceTime: raceTime,
	                    raceDate: raceDate,
	                    horseName: horseName,
	                    bookmaker: bookmaker
	                });
	                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
	                    courseName: courseName,
	                    raceTime: raceTime,
	                    raceDate: raceDate,
	                    bookmaker: bookmaker
	                });
	
	                return [priceTopic, infoTopic];
	            }).reduce(function (acum, value) {
	                return acum.concat(value);
	            }, []).filter(function (topic) {
	                return topic;
	            });
	
	            this.subscriber.subscribe(topics);
	        }
	    }, {
	        key: 'unsubscribeFromPrices',
	        value: function unsubscribeFromPrices(horsesList, bookmaker) {
	            var _this2 = this;
	
	            horsesList.map(function (horseData) {
	                return _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(_extends(horseData, { bookmaker: bookmaker }));
	            }).filter(function (topic) {
	                return topic;
	            }).forEach(function (topic) {
	                return _this2.session.unsubscribe({ topic: topic });
	            });
	        }
	    }, {
	        key: 'onDataReceive',
	        value: function onDataReceive(WebClientMessage) {
	            var topic = WebClientMessage.getTopic();
	
	            if (topic.includes('#INFO')) {
	                this.handleRaceInfo(WebClientMessage);
	            } else {
	                this.handleHorsePrice(WebClientMessage);
	            }
	        }
	    }, {
	        key: 'onConnectionStatusChange',
	        value: function onConnectionStatusChange(isOpened) {
	            if (isOpened) {
	                this.subscriber.run();
	            } else {
	                this.subscriber.stop();
	            }
	        }
	    }, {
	        key: 'handleHorsePrice',
	        value: function handleHorsePrice(WebClientMessage) {
	            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);
	
	            this.publish(PRICE_HANDLER_EVENTS.PRICE_RECEIVED, renderConfig);
	            (0, _jquery2.default)(document).trigger(_EVENTS2.default.PRICES_NEED_SORTING);
	        }
	    }, {
	        key: 'handleRaceInfo',
	        value: function handleRaceInfo(WebClientMessage) {
	            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);
	
	            _PricesStateStore.pricesStateStore.updateRaceInfo(renderConfig);
	            this.publish(PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, renderConfig);
	        }
	    }]);
	
	    return PricesProvider;
	}(_PubSub3.default);
	// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
	
	
	var pricesProvider = exports.pricesProvider = new PricesProvider();

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    USER_SETTINGS_CHANGED: 'userSettingsChanged.SETTINGS',
	    DYNAMIC_PRICES_UPDATED: 'dynamicPricesUpdated.PRICES',
	    RESIZE: 'resize',
	    SWITCH_BREAKPOINTS: 'rpBreakpointsSwitch',
	    MAKE_SELECTION: 'RC.makeSelection',
	    BOOKMAKER_CHANGED: 'bookieChanged.BOOKMAKER',
	    INFO_TOPIC_UPDATED: 'infoTopicUpdate.PRICES',
	    HORSES_LIST_CHANGED: 'horsesListChanged',
	    // TODO: RC - Race card related prefix (JIRA: PC-4557)
	    PRICES_NEED_SORTING: 'RC.priceUpdatedToSort'
	};

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.horsesListStore = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var newHorseElementsSelector = '.js-diffusionHorsesList:not(.js-PC-subscribed)';
	var subscribedHorseseClass = 'js-PC-subscribed';
	
	var HorsesListStore = function () {
	    function HorsesListStore() {
	        _classCallCheck(this, HorsesListStore);
	
	        this.horsesList = [];
	    }
	
	    _createClass(HorsesListStore, [{
	        key: 'getHorsesList',
	        value: function getHorsesList() {
	            return this.horsesList;
	        }
	
	        // TODO: move to private function, utils or static method (JIRA: PC-4559)
	        /* eslint-disable class-methods-use-this */
	
	    }, {
	        key: 'getNotSubscribedHorses',
	        value: function getNotSubscribedHorses() {
	            var diffusionHorsesNodeList = (0, _jquery2.default)(newHorseElementsSelector).toArray();
	            var notSubscribedHorses = diffusionHorsesNodeList.map(_DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData.bind(_DiffusionServiceUtils.diffusionServiceUtils));
	
	            diffusionHorsesNodeList.forEach(function (element) {
	                element.classList.add(subscribedHorseseClass);
	            });
	
	            return notSubscribedHorses;
	        }
	        /* eslint-enable class-methods-use-this */
	
	    }, {
	        key: 'updateHorsesData',
	        value: function updateHorsesData() {
	            var notSubscribedHorses = this.getNotSubscribedHorses();
	
	            this.horsesList = this.horsesList.concat(notSubscribedHorses);
	
	            return notSubscribedHorses;
	        }
	    }]);
	
	    return HorsesListStore;
	}();
	// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
	/* eslint-disable import/prefer-default-export */
	
	
	var horsesListStore = exports.horsesListStore = new HorsesListStore();

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PopOver = function () {
	    function PopOver(popOverConfig) {
	        _classCallCheck(this, PopOver);
	
	        var defaultConfig = {
	            popOverSelector: '.js-popOver',
	            openAreaSelectors: ['.js-popOver__openArea'],
	            toggleAreaSelector: '.js-popOver__toggleArea',
	            closeAreaSelectors: ['.js-popOver__shadow', '.js-popOver__closeBtn'],
	            activeClass: 'ui-popOver_active',
	            onOpen: null,
	            onClose: null,
	            name: ''
	        };
	        this.config = _jquery2.default.extend(true, defaultConfig, popOverConfig);
	        this.init();
	    }
	
	    _createClass(PopOver, [{
	        key: 'init',
	        value: function init() {
	            this.popOver = (0, _jquery2.default)(this.config.popOverSelector)[0];
	            this.openArea = (0, _jquery2.default)(this.config.openAreaSelectors.join(','));
	            this.toggleArea = (0, _jquery2.default)(this.config.toggleAreaSelector)[0];
	            this.closeArea = (0, _jquery2.default)(this.config.closeAreaSelectors.join(','));
	
	            this.bindEvents();
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            var _this = this;
	
	            Array.prototype.forEach.call(this.openArea, function (element) {
	                return element.addEventListener('click', function (e) {
	                    _this.onOpenAreaClicked(e);
	                }, false);
	            });
	
	            if (this.toggleArea) {
	                this.toggleArea.addEventListener('click', function (e) {
	                    _this.onTogglePopOver(e);
	                }, false);
	            }
	
	            Array.prototype.forEach.call(this.closeArea, function (element) {
	                return element.addEventListener('click', function (e) {
	                    _this.onCloseAreaClicked(e);
	                }, false);
	            });
	        }
	    }, {
	        key: 'onOpenAreaClicked',
	        value: function onOpenAreaClicked(event) {
	            event.preventDefault();
	            this.open(event);
	        }
	    }, {
	        key: 'onTogglePopOver',
	        value: function onTogglePopOver(event) {
	            event.preventDefault();
	            this.toggle();
	        }
	    }, {
	        key: 'onCloseAreaClicked',
	        value: function onCloseAreaClicked(event) {
	            this.close(event);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            var _this2 = this;
	
	            Array.prototype.forEach.call(this.openArea, function (element) {
	                element.removeEventListener('click', function (e) {
	                    _this2.onOpenAreaClicked(e);
	                }, false);
	            });
	
	            if (this.toggleArea) {
	                this.toggleArea.removeEventListener('click', function (e) {
	                    _this2.onTogglePopOver(e);
	                }, false);
	            }
	
	            Array.prototype.forEach.call(this.closeArea, function (element) {
	                element.removeEventListener('click', function (e) {
	                    _this2.onCloseAreaClicked(e);
	                }, false);
	            });
	        }
	    }, {
	        key: 'toggle',
	        value: function toggle() {
	            if (this.isActive()) {
	                this.close();
	            } else {
	                this.open();
	            }
	        }
	    }, {
	        key: 'open',
	        value: function open(event) {
	            if (this.popOver) {
	                this.popOver.classList.add(this.config.activeClass);
	            }
	
	            if (this.config.onOpen instanceof Function) {
	                this.config.onOpen(event);
	            }
	
	            _jquery2.default.event.trigger('popoverOpened' + this.config.name);
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            if (this.config.onClose instanceof Function) {
	                this.config.onClose();
	            }
	
	            if (this.popOver) {
	                this.popOver.classList.remove(this.config.activeClass);
	            }
	
	            _jquery2.default.event.trigger('popoverClosed' + this.config.name);
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive() {
	            return this.popOver.classList.contains(this.config.activeClass);
	        }
	    }]);
	
	    return PopOver;
	}();
	
	exports.default = PopOver;

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
	exports.getPrefValue = getPrefValue;
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
	var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
	var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';
	
	function getValuesIfExist(value, possibleValues) {
	    return value in possibleValues;
	}
	
	function getPrefValue(prefType, prefDefaultValue) {
	    return localStorage.getItem(prefType) || prefDefaultValue;
	}
	
	function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
	    var prefValue = void 0;
	
	    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
	        var $target = (0, _jquery2.default)(e.currentTarget);
	
	        function updateHref(value) {
	            $target.attr('href', function (index, href) {
	                return '' + href.replace(/\/$/, '') + possibleValues[value];
	            });
	            $target.removeClass(className);
	        }
	
	        if (prefValue) {
	            updateHref(prefValue);
	        } else {
	            prefValue = getPrefValue(prefType, prefDefaultValue);
	            updateHref(prefValue);
	        }
	    });
	}
	
	function setPref(selector, storageKeyName, possibleValues) {
	    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
	    if (!getValuesIfExist(value, possibleValues)) {
	        return;
	    }
	
	    if (value) {
	        try {
	            localStorage.setItem(storageKeyName, value);
	        } catch (e) {
	            /* eslint-disable no-console */
	            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
	        }
	    }
	}
	
	function navigate() {
	    var cardTabsPossibleValues = {
	        free: '/',
	        pro: '/pro',
	        'at-a-glance': '/at-a-glance',
	        'odds-comparison': '/odds-comparison',
	        'raceday-live': '/raceday-live'
	    };
	    var cardListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    var resultsListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    // Racecards tab preferences
	    // TODO: change to more related name
	    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
	    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);
	
	    // Racecards list types preferences
	    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
	    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);
	
	    // Results list types preferences
	    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
	    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
	}
	
	exports.default = navigate;

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.Advertisement = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(135);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering advertisements
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function Advertisement(_ref) {
	    var position = _ref.position,
	        className = _ref.className,
	        isActive = _ref.isActive,
	        isCentered = _ref.isCentered;
	
	    var asideClass = (0, _classnames2.default)('ui-advertising__container', 'js-advertising__placeholder' + position + ' ' + className);
	    var dataTestSelector = 'block-advertising_position' + position;
	    var styleObject = isCentered ? { flexDirection: 'column' } : {};
	
	    return isActive ? _react2.default.createElement('aside', {
	        className: asideClass,
	        'data-test-selector': dataTestSelector,
	        style: styleObject
	    }) : null;
	}
	
	Advertisement.defaultProps = {
	    className: '',
	    isCentered: false
	};
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	    var advertisement = _ref2.advertisement;
	    var position = _ref3.position;
	    return {
	        isActive: !!advertisement.find(function (ad) {
	            return ad.position === position && ad.isActive;
	        })
	    };
	};
	
	var ConnectedAdvertisement = (0, _reactRedux.connect)(mapStateToProps)(Advertisement);
	
	exports.Advertisement = Advertisement;
	exports.default = ConnectedAdvertisement;

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	/**
	 * Advertisement reducer
	 * @param state
	 * @returns {Array}
	 */
	
	function advertisement() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.advertisement;
	
	  return state;
	}
	
	exports.default = advertisement;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Advertisement = __webpack_require__(247);
	
	var _Advertisement2 = _interopRequireDefault(_Advertisement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering list of advertisement on the sidebar
	 * Position description you can found there:
	 * https://docs.google.com/spreadsheets/d/1A3s9YjyVhmBcrh5kMl8i2P3RJEyAcUhmwwthISf4gl8/edit#gid=834985875
	 * Active position is determined by backend preloaded state
	 * @see advertisement.reducer.js
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function AdvertisementList() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Advertisement2.default, { position: 9 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 3 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 10 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 11 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 12 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 13 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 14 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 32 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 33 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 34 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 16 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 17 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 18 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 19 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 20 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 21 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 22 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 23 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 24 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 25 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 26 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 4 }),
	        _react2.default.createElement(_Advertisement2.default, { position: 42 })
	    );
	}
	
	exports.default = AdvertisementList;

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AdvertisementList = __webpack_require__(675);
	
	var _AdvertisementList2 = _interopRequireDefault(_AdvertisementList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AdvertisementList module exports
	 */
	exports.default = _AdvertisementList2.default; /**
	                                                * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                                */

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpAdvertising = __webpack_require__(378);
	
	var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);
	
	var _rpBettingSpecialOffer = __webpack_require__(1476);
	
	var _rpBettingSpecialOffer2 = _interopRequireDefault(_rpBettingSpecialOffer);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Cards = __webpack_require__(696);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _News = __webpack_require__(705);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _BookmakerRegPanel = __webpack_require__(398);
	
	var _BookmakerRegPanel2 = _interopRequireDefault(_BookmakerRegPanel);
	
	var _RacedayLive = __webpack_require__(708);
	
	var _RacedayLive2 = _interopRequireDefault(_RacedayLive);
	
	var _Advertisement = __webpack_require__(247);
	
	var _Advertisement2 = _interopRequireDefault(_Advertisement);
	
	var _Sidebar = __webpack_require__(710);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _contentHubHelper = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used as a main entry point in application
	 * It consists of:
	 * <Cards />
	 * <BookmakerRegPanel />
	 * <RacedayLive />
	 * <Sidebar />
	 */
	var App = function (_PureComponent) {
	    (0, _inherits3.default)(App, _PureComponent);
	
	    function App() {
	        (0, _classCallCheck3.default)(this, App);
	        return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _rpAdvertising2.default)();
	            (0, _rpBettingSpecialOffer2.default)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isContentHub = (0, _contentHubHelper.isContentHubPage)();
	            var hasRacedayLive = (0, _contentHubHelper.checkForRacedayLive)();
	            var hasRegPanel = (0, _contentHubHelper.checkForRegPanel)();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ui-canvas ui-advertising__skinsWrp' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui-content' },
	                    _react2.default.createElement(
	                        'main',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: (0, _classnames2.default)('ui-mainContent', isContentHub && 'rh-contentHub__container')
	                            },
	                            !isContentHub && _react2.default.createElement(_Cards2.default, null),
	                            hasRegPanel && _react2.default.createElement(_BookmakerRegPanel2.default, { isMobile: true }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rh-newsSection' },
	                                _react2.default.createElement(_News2.default, null),
	                                hasRacedayLive && _react2.default.createElement(_RacedayLive2.default, null)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_Advertisement2.default, { position: 2 })
	                ),
	                _react2.default.createElement(_Sidebar2.default, null),
	                _react2.default.createElement(_Advertisement2.default, { position: 40 }),
	                _react2.default.createElement(_Advertisement2.default, { position: 41 })
	            );
	        }
	    }]);
	    return App;
	}(_react.PureComponent); /**
	                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                          */
	
	exports.default = App;

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _App = __webpack_require__(677);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * App module exports
	 */
	exports.default = _App2.default; /**
	                                  * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                  */

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.BookmakerRegPanel = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(135);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering Bookmaker Registration Panel
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function BookmakerRegPanel(_ref) {
	    var panelTemplate = _ref.panelTemplate,
	        isMobile = _ref.isMobile;
	
	    return _react2.default.createElement('div', {
	        className: (0, _classnames2.default)('rh-bookmaker-panel', {
	            'rh-bookmakers--mobile': isMobile
	        }),
	        dangerouslySetInnerHTML: { __html: panelTemplate[0] }
	    });
	}
	
	BookmakerRegPanel.defaultProps = {
	    isMobile: false
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	    var panelTemplate = _ref2.panelTemplate;
	    return {
	        panelTemplate: panelTemplate
	    };
	};
	
	var ConnectedBookmakerRegPanel = (0, _reactRedux.connect)(mapStateToProps)(BookmakerRegPanel);
	
	exports.BookmakerRegPanel = BookmakerRegPanel;
	exports.default = ConnectedBookmakerRegPanel;

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function panelTemplate() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.panelTemplate;
	
	  return state;
	}
	
	/**
	 * panelTemplate reducer
	 */
	exports.default = panelTemplate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function bookmakers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.bookmakers;
	
	  return state;
	}
	
	/**
	 * Bookmakers reducer
	 */
	exports.default = bookmakers;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.Cards = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(135);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rpNavigation = __webpack_require__(388);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _rpUrlNavigationPrefs = __webpack_require__(641);
	
	var _CardsMatrix = __webpack_require__(687);
	
	var _CardsMatrix2 = _interopRequireDefault(_CardsMatrix);
	
	var _CardsMeetingsBtn = __webpack_require__(689);
	
	var _CardsMeetingsBtn2 = _interopRequireDefault(_CardsMeetingsBtn);
	
	var _CardsError = __webpack_require__(685);
	
	var _CardsError2 = _interopRequireDefault(_CardsError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CARDS_PRO_TAB = 'pro'; /**
	                            * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                            */
	
	var CARDS_FREE_TAB = 'free';
	
	/**
	 * Component that is used for rendering cards
	 */
	
	var Cards = function (_Component) {
	    (0, _inherits3.default)(Cards, _Component);
	
	    function Cards() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Cards);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Cards.__proto__ || (0, _getPrototypeOf2.default)(Cards)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isAnchorSet: false,
	            prefTab: '',
	            isExpanded: false,
	            currentBreakpointCode: _rpMqBreakpoints2.default.current().code,
	            matrixEpandedHeight: _this.getMatrixHeight(true),
	            matrixCollapsedHeight: _this.getMatrixHeight(false)
	        }, _this.setCurrentBreakpointCode = function (event) {
	            var code = event.detail.breakpoint.code;
	            _this.setState({
	                currentBreakpointCode: code
	            });
	        }, _this.getTitle = function () {
	            var _this$props = _this.props,
	                shortHeading = _this$props.shortHeading,
	                heading = _this$props.heading;
	            var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	                NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;
	
	            return [EXTRA_NARROW, NARROW].includes(_this.state.currentBreakpointCode) ? shortHeading : heading;
	        }, _this.isMatrixExpandable = function () {
	            var currentBreakpointCode = _this.state.currentBreakpointCode;
	            var _this$props2 = _this.props,
	                courses = _this$props2.courses,
	                meetingsMaxAmountFromMedium = _this$props2.meetingsMaxAmountFromMedium;
	            var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
	                EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;
	
	
	            return [NARROW, EXTRA_NARROW].indexOf(currentBreakpointCode) > -1 ? false : courses.length > meetingsMaxAmountFromMedium;
	        }, _this.updateCardLinks = function (isLoggedIn) {
	            var prefTab = (0, _rpUrlNavigationPrefs.getPrefValue)(_rpUrlNavigationPrefs.CARDS_PREFERRED_TAB, CARDS_FREE_TAB);
	            _this.setState({
	                isAnchorSet: prefTab !== CARDS_PRO_TAB || isLoggedIn,
	                prefTab: prefTab
	            });
	        }, _this.toggleMeetings = function () {
	            if (_this.state.isExpanded) {
	                _this.hideMeetings();
	            } else {
	                _this.showMeetings();
	            }
	        }, _this.hideMeetings = function () {
	            var matrixNode = document.getElementById('cardsMatrix');
	            matrixNode.setAttribute('style', 'max-height:' + _this.state.matrixCollapsedHeight + 'px');
	
	            _this.setState({
	                isExpanded: false
	            });
	        }, _this.showMeetings = function () {
	            var matrixNode = document.getElementById('cardsMatrix');
	
	            matrixNode.setAttribute('style', 'max-height:' + _this.state.matrixEpandedHeight + 'px');
	
	            _this.setState({
	                isExpanded: true
	            });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Cards, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _rpNavigation.authReady.then(function (auth) {
	                _this2.updateCardLinks(auth.user.isLoggedIn);
	            });
	
	            window.addEventListener('rpBreakpointsSwitch', this.setCurrentBreakpointCode);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('rpBreakpointsSwitch', this.setCurrentBreakpointCode);
	        }
	    }, {
	        key: 'getMatrixHeight',
	        value: function getMatrixHeight(isExpanded) {
	            var _props = this.props,
	                courses = _props.courses,
	                meetingsMaxAmountFromMedium = _props.meetingsMaxAmountFromMedium,
	                courseHeight = _props.courseHeight,
	                abandonedHeight = _props.abandonedHeight;
	
	            var numberOfCourses = isExpanded ? courses.length : meetingsMaxAmountFromMedium;
	            var matrixHeight = 0;
	
	            for (var i = 0; i < numberOfCourses; i += 1) {
	                if (courses[i] && !courses[i].abandoned) {
	                    matrixHeight += courseHeight;
	                } else {
	                    matrixHeight += abandonedHeight;
	                }
	            }
	
	            return matrixHeight;
	        }
	
	        /**
	         * Method that is used for rendering date alias:
	         * Today's or Tomorrow's, if it exists
	         * @returns {string}
	         */
	
	
	        /**
	         * Method that is used for toggling meetings
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                date = _props2.date,
	                courses = _props2.courses;
	            var _state = this.state,
	                isAnchorSet = _state.isAnchorSet,
	                isExpanded = _state.isExpanded,
	                prefTab = _state.prefTab,
	                matrixCollapsedHeight = _state.matrixCollapsedHeight,
	                currentBreakpointCode = _state.currentBreakpointCode;
	
	            var cardsClass = (0, _classnames2.default)('rh-cards', {
	                'rh-cards--expanded': isExpanded
	            });
	            var isExpandable = this.isMatrixExpandable();
	
	            return courses.length > 0 ? _react2.default.createElement(
	                'section',
	                { className: cardsClass, id: 'cardsBlock' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rh-cardsHeader' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'rh-cardsHeader__title' },
	                        this.getTitle()
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rh-cardsHeader__linkContainer' },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: (0, _classnames2.default)('rh-cardsHeader__link', 'ui-link', 'ui-link_table', 'js-popupLink'),
	                                href: '/non-runners/' + date
	                            },
	                            'Going and non-runners',
	                            _react2.default.createElement(_rpReactSvgIcon2.default, {
	                                className: 'ui-icon ui-icon__btn',
	                                iconName: 'right',
	                                size: 'Small'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: (0, _classnames2.default)('rh-cardsHeader__link', 'ui-link', 'ui-link_table', 'js-navigate-url'),
	                                href: '/racecards/next-race'
	                            },
	                            'Next race off',
	                            _react2.default.createElement(_rpReactSvgIcon2.default, {
	                                className: 'ui-icon ui-icon__btn',
	                                iconName: 'right',
	                                size: 'Small'
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(_CardsMatrix2.default, {
	                    courses: courses,
	                    date: date,
	                    isAnchorSet: isAnchorSet,
	                    prefTab: prefTab,
	                    height: matrixCollapsedHeight,
	                    isExpandable: isExpandable,
	                    currentBreakpointCode: currentBreakpointCode
	                }),
	                isExpandable && _react2.default.createElement(_CardsMeetingsBtn2.default, {
	                    onClick: this.toggleMeetings,
	                    isExpanded: isExpanded
	                })
	            ) : _react2.default.createElement(_CardsError2.default, null);
	        }
	    }], [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                meetingsMaxAmountFromMedium: 6,
	                courseHeight: 64,
	                abandonedHeight: 46
	            };
	        }
	    }]);
	    return Cards;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	    var _ref2$cards = _ref2.cards,
	        courses = _ref2$cards.courses,
	        _ref2$cards$date = _ref2$cards.date,
	        shortHeading = _ref2$cards$date.shortHeading,
	        heading = _ref2$cards$date.heading,
	        date = _ref2$cards$date.date;
	    return {
	        courses: courses,
	        date: date,
	        shortHeading: shortHeading,
	        heading: heading
	    };
	};
	
	var ConnectedCards = (0, _reactRedux.connect)(mapStateToProps)(Cards);
	
	exports.Cards = Cards;
	exports.default = ConnectedCards;

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(138);
	
	/**
	 * Courses reducer
	 * @param state
	 * @returns {Array}
	 */
	function courses() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.cardsMatrix.courses;
	
	    return state;
	}
	
	/**
	 * Date reducer
	 * @param state
	 * @returns {object}
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function date() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        date: global.__PRELOADED_STATE.cardsMatrix.date,
	        heading: global.__PRELOADED_STATE.cardsMatrix.heading,
	        shortHeading: global.__PRELOADED_STATE.cardsMatrix.shortHeading
	    };
	
	    return state;
	}
	
	exports.default = (0, _redux.combineReducers)({
	    courses: courses,
	    date: date
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering <CardsError />
	 * It tells that some problem occurs during to retrieving races
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var CardsError = function CardsError() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'rh-cards__errorsHandle ui-errorMessage' },
	        _react2.default.createElement(_rpReactSvgIcon2.default, { isInlined: true, iconName: 'results', selector: 'img-errorMessageImage' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'ui-errorMessage__container', 'data-test-selector': 'text-errorMessageText' },
	            _react2.default.createElement(
	                'span',
	                { className: 'ui-errorMessage__text' },
	                'Data currently unavailable, please try again later.'
	            )
	        )
	    );
	};
	
	exports.default = CardsError;

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CardsError = __webpack_require__(684);
	
	var _CardsError2 = _interopRequireDefault(_CardsError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CardsError module exports
	 */
	exports.default = _CardsError2.default; /**
	                                         * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                         */

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.getChevronFormTarget = exports.getLeftOffset = exports.setScheduleState = exports.scrollToNextRace = exports.checkIfRightChevronIsActive = exports.checkIfLeftChevronIsActive = exports.setDisabledClass = exports.addFirstRaceElemClass = exports.checkIfTouchScreen = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _CourseInfo = __webpack_require__(691);
	
	var _CourseInfo2 = _interopRequireDefault(_CourseInfo);
	
	var _CourseSchedule = __webpack_require__(693);
	
	var _CourseSchedule2 = _interopRequireDefault(_CourseSchedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var CLASS_DISABLED = 'rh-cardsMatrix__chevron--disabled';
	var CLASS_FIRST = 'rh-cardsMatrix__race--first';
	var CLASS_SCROLLABLE = 'rh-cardsMatrix__races--scrollable';
	
	function checkIfTouchScreen() {
	    if ('ontouchstart' in document.documentElement) return true;
	    return false;
	}
	
	function addFirstRaceElemClass(schedule, raceNumber) {
	    var firstElem = schedule.querySelector('.' + CLASS_FIRST);
	
	    if (firstElem) {
	        firstElem.classList.remove(CLASS_FIRST);
	    }
	    schedule.children[raceNumber].classList.add(CLASS_FIRST);
	}
	
	function setDisabledClass(chevron, isActiveChevron) {
	    if (!isActiveChevron && !chevron.classList.contains(CLASS_DISABLED)) {
	        chevron.classList.add(CLASS_DISABLED);
	    }
	
	    if (isActiveChevron && chevron.classList.contains(CLASS_DISABLED)) {
	        chevron.classList.remove(CLASS_DISABLED);
	    }
	}
	
	function checkIfLeftChevronIsActive(schedule) {
	    if (schedule.style.left.length > 0 && schedule.style.left.split('px')[0] !== '0') {
	        return true;
	    }
	
	    return false;
	}
	
	function checkIfRightChevronIsActive(schedule, raceWidth, maxRaces) {
	    if (schedule.style.left !== (maxRaces - schedule.childElementCount) * raceWidth + 'px' && maxRaces < schedule.childElementCount) {
	        return true;
	    }
	
	    return false;
	}
	/* Logic for showing the next race in meeting is:
	    * shifting starts when next race goes to the fists slot that is not fully visible
	    * the next race should be in the last fully visible slot
	    * first visible race should be half hidden
	*/
	
	function scrollToNextRace(schedule, isTouchScreen, raceWidth, maxRaces) {
	    var passedRaces = schedule.querySelectorAll('.rh-cardsMatrix__race--result');
	
	    if (isTouchScreen) {
	        var nextRaceInOffsetLeft = passedRaces.length && passedRaces[passedRaces.length - 1].offsetLeft + raceWidth;
	        var visibleSlots = Math.floor(schedule.clientWidth / raceWidth);
	        var slotsToShift = schedule.clientWidth % raceWidth > raceWidth / 2 ? visibleSlots : visibleSlots - 1;
	
	        if (nextRaceInOffsetLeft && schedule.clientWidth < nextRaceInOffsetLeft + raceWidth) {
	            var step = (slotsToShift - 0.5) * raceWidth;
	            schedule.scrollLeft = nextRaceInOffsetLeft - step;
	        }
	    } else if (passedRaces.length >= maxRaces) {
	        var _slotsToShift = schedule.childElementCount - passedRaces.length >= maxRaces ? passedRaces.length - (maxRaces - 1) : schedule.childElementCount - maxRaces;
	
	        schedule.setAttribute('style', 'left: ' + -_slotsToShift * raceWidth + 'px');
	        addFirstRaceElemClass(schedule, _slotsToShift);
	    }
	}
	
	function setScheduleState(schedule, raceWidth, maxRaces) {
	    var leftChevron = schedule.parentNode.previousSibling;
	    var rightChevron = schedule.parentNode.nextSibling;
	
	    schedule.setAttribute('style', '');
	
	    if (schedule.classList.contains(CLASS_SCROLLABLE)) {
	        scrollToNextRace(schedule, false, raceWidth, maxRaces);
	    }
	
	    setDisabledClass(leftChevron, checkIfLeftChevronIsActive(schedule));
	    setDisabledClass(rightChevron, checkIfRightChevronIsActive(schedule, raceWidth, maxRaces));
	}
	
	function getLeftOffset(schedule) {
	    var leftOffset = schedule.style.left.split('px')[0];
	    if (leftOffset.length > 0) {
	        return Number(leftOffset);
	    }
	    return 0;
	}
	
	function getChevronFormTarget(target) {
	    while (!target.classList || !target.classList.contains('rh-cardsMatrix__chevron')) {
	        target = target.parentNode;
	    }
	
	    return target;
	}
	
	/**
	 * Component that is used for rendering cardsMatrix
	 */
	
	var CardsMatrix = function (_Component) {
	    (0, _inherits3.default)(CardsMatrix, _Component);
	
	    function CardsMatrix() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, CardsMatrix);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardsMatrix.__proto__ || (0, _getPrototypeOf2.default)(CardsMatrix)).call.apply(_ref, [this].concat(args))), _this), _this.onLeftChevronClick = function (event) {
	            var leftChevron = getChevronFormTarget(event.target);
	            var schedule = leftChevron.nextSibling.firstElementChild;
	            var rightChevron = schedule.parentNode.nextSibling;
	            var raceWidth = _this.props.raceWidth;
	
	            var maxRaces = _this.getMaxRaces();
	
	            if (checkIfLeftChevronIsActive(schedule)) {
	                var newleftOffset = getLeftOffset(schedule) + raceWidth;
	
	                schedule.setAttribute('style', 'left: ' + newleftOffset + 'px');
	                addFirstRaceElemClass(schedule, -newleftOffset / raceWidth);
	                setDisabledClass(leftChevron, checkIfLeftChevronIsActive(schedule));
	                setDisabledClass(rightChevron, checkIfRightChevronIsActive(schedule, raceWidth, maxRaces));
	            }
	        }, _this.onRightChevronClick = function (event) {
	            var rightChevron = getChevronFormTarget(event.target);
	            var schedule = rightChevron.previousSibling.firstElementChild;
	            var leftChevron = schedule.parentNode.previousSibling;
	            var raceWidth = _this.props.raceWidth;
	
	            var maxRaces = _this.getMaxRaces();
	
	            if (checkIfRightChevronIsActive(schedule, raceWidth, maxRaces)) {
	                var newleftOffset = getLeftOffset(schedule) - raceWidth;
	
	                schedule.setAttribute('style', 'left: ' + newleftOffset + 'px');
	                addFirstRaceElemClass(schedule, -newleftOffset / raceWidth);
	
	                setDisabledClass(leftChevron, checkIfLeftChevronIsActive(schedule));
	                setDisabledClass(rightChevron, checkIfRightChevronIsActive(schedule, raceWidth, maxRaces));
	            }
	        }, _this.getMaxRaces = function () {
	            var _this$props = _this.props,
	                racesMaxAmountExWide = _this$props.racesMaxAmountExWide,
	                racesMaxAmount = _this$props.racesMaxAmount,
	                currentBreakpointCode = _this$props.currentBreakpointCode;
	            var EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;
	
	
	            return currentBreakpointCode === EXTRA_WIDE ? racesMaxAmountExWide : racesMaxAmount;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CardsMatrix, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var schedules = document.querySelectorAll('.rh-cardsMatrix__races');
	            var isTouchScreen = checkIfTouchScreen();
	            var maxRaces = this.getMaxRaces();
	            var raceWidth = this.props.raceWidth;
	
	
	            if (schedules && schedules.length > 0) {
	                var isScrollable = this.props.courses.find(function (course) {
	                    return course.races.length > maxRaces;
	                });
	
	                for (var i = 0; i < schedules.length; i += 1) {
	                    if (!isTouchScreen && isScrollable) {
	                        setScheduleState(schedules[i], raceWidth, maxRaces);
	                    } else {
	                        scrollToNextRace(schedules[i], isTouchScreen, raceWidth, maxRaces);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.currentBreakpointCode !== this.props.currentBreakpointCode && !checkIfTouchScreen()) {
	                var schedules = document.querySelectorAll('.rh-cardsMatrix__races');
	                var maxRaces = this.getMaxRaces();
	                var isScrollable = this.props.courses.find(function (course) {
	                    return course.races.length > maxRaces;
	                });
	
	                if (schedules && schedules.length > 0 && isScrollable) {
	                    for (var i = 0; i < schedules.length; i += 1) {
	                        var firstElem = schedules[i].querySelector('.' + CLASS_FIRST);
	
	                        if (firstElem) {
	                            firstElem.classList.remove(CLASS_FIRST);
	                        }
	
	                        setScheduleState(schedules[i], this.props.raceWidth, maxRaces);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                courses = _props.courses,
	                date = _props.date,
	                isAnchorSet = _props.isAnchorSet,
	                prefTab = _props.prefTab,
	                height = _props.height,
	                isExpandable = _props.isExpandable;
	
	            var maxRaces = this.getMaxRaces();
	            var isScrollable = courses.find(function (course) {
	                return course.races.length > maxRaces;
	            });
	            var styles = isExpandable ? { maxHeight: height + 'px' } : {};
	            var isTouchScreen = checkIfTouchScreen();
	            var chevronClassNames = 'rh-cardsMatrix__chevron rh-cardsMatrix__chevron--disabled';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rh-cardsMatrix', id: 'cardsMatrix', style: styles },
	                courses.map(function (course) {
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'rh-cardsMatrix__course ' + (course.abandoned ? 'rh-cardsMatrix__course--abandoned' : ''),
	                            key: course.id
	                        },
	                        _react2.default.createElement(_CourseInfo2.default, { course: course, date: date }),
	                        isScrollable && !isTouchScreen ? _react2.default.createElement(
	                            'div',
	                            { className: 'rh-cardsMatrix__scheduleContainer' },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: chevronClassNames,
	                                    onClick: _this2.onLeftChevronClick
	                                },
	                                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                                    className: 'rh-arrow',
	                                    iconName: 'left', size: 'Medium'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rh-cardsMatrix__racesContainer' },
	                                _react2.default.createElement(_CourseSchedule2.default, {
	                                    course: course,
	                                    isAnchorSet: isAnchorSet,
	                                    prefTab: prefTab,
	                                    isScrollable: course.races.length > maxRaces
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: chevronClassNames,
	                                    onClick: _this2.onRightChevronClick
	                                },
	                                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                                    isInlined: true,
	                                    className: 'rh-arrow',
	                                    iconName: 'right',
	                                    size: 'Medium'
	                                })
	                            )
	                        ) : _react2.default.createElement(_CourseSchedule2.default, {
	                            course: course,
	                            isAnchorSet: isAnchorSet,
	                            prefTab: prefTab
	                        })
	                    );
	                })
	            );
	        }
	    }], [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                racesMaxAmountExWide: 7,
	                racesMaxAmount: 4,
	                raceWidth: 90
	            };
	        }
	    }]);
	    return CardsMatrix;
	}(_react.Component);
	
	exports.checkIfTouchScreen = checkIfTouchScreen;
	exports.addFirstRaceElemClass = addFirstRaceElemClass;
	exports.setDisabledClass = setDisabledClass;
	exports.checkIfLeftChevronIsActive = checkIfLeftChevronIsActive;
	exports.checkIfRightChevronIsActive = checkIfRightChevronIsActive;
	exports.scrollToNextRace = scrollToNextRace;
	exports.setScheduleState = setScheduleState;
	exports.getLeftOffset = getLeftOffset;
	exports.getChevronFormTarget = getChevronFormTarget;
	exports.default = CardsMatrix;

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CardsMatrix = __webpack_require__(686);
	
	var _CardsMatrix2 = _interopRequireDefault(_CardsMatrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CardsMatrix module exports
	 */
	exports.default = _CardsMatrix2.default; /**
	                                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                          */

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BUTTON_STATE = {
	    SHOW: 'Show All Meetings',
	    HIDE: 'Hide Meetings'
	};
	
	/**
	 * Component that is used for rendering Button, which change display state of cards
	 * It displays different title regarding on state of CardsMatrix
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function CardsMeetingsBtn(_ref) {
	    var onClick = _ref.onClick,
	        isExpanded = _ref.isExpanded;
	
	    var btnText = isExpanded ? BUTTON_STATE.HIDE : BUTTON_STATE.SHOW;
	    return _react2.default.createElement(
	        'button',
	        {
	            type: 'button',
	            className: 'rh-cardsMeetingsBtn ui-btn',
	            id: 'cardsMeetingsBtn',
	            onClick: onClick
	        },
	        _react2.default.createElement(
	            'span',
	            { className: 'rh-cardsMeetingsBtn__label' },
	            btnText
	        ),
	        _react2.default.createElement(_rpReactSvgIcon2.default, { isInlined: true, iconName: 'down', size: 'Medium', className: 'rh-cardsMeetingsBtn__icon' })
	    );
	}
	
	exports.default = CardsMeetingsBtn;

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CardsMeetingBtn = __webpack_require__(688);
	
	var _CardsMeetingBtn2 = _interopRequireDefault(_CardsMeetingBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CardsMeetingBtn module exports
	 */
	exports.default = _CardsMeetingBtn2.default; /**
	                                              * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                              */

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering course title
	 */
	var CourseInfo = function (_PureComponent) {
	    (0, _inherits3.default)(CourseInfo, _PureComponent);
	
	    function CourseInfo() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, CourseInfo);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CourseInfo.__proto__ || (0, _getPrototypeOf2.default)(CourseInfo)).call.apply(_ref, [this].concat(args))), _this), _this.getCourseDetails = function (course) {
	            var meetingTypeCode = course.meetingTypeCode,
	                races = course.races,
	                allWeather = course.allWeather,
	                surfaceType = course.surfaceType;
	
	            var allWeatherLabel = allWeather ? (surfaceType && surfaceType.length > 0 ? surfaceType : 'All-weather') + ' | ' : '';
	            var raceLabel = races.length > 1 ? 'races' : 'race';
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'rh-cardsMatrix__courseDetails' },
	                meetingTypeCode + ' | ' + allWeatherLabel + races.length + ' ' + raceLabel
	            );
	        }, _this.getCourseInfo = function (course) {
	            var name = course.name,
	                countryCode = course.countryCode;
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'rh-cardsMatrix__courseTitleContainer' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'rh-cardsMatrix__courseName' },
	                    name
	                ),
	                countryCode !== 'GB' && _react2.default.createElement(
	                    'span',
	                    null,
	                    ' (',
	                    countryCode,
	                    ')'
	                )
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CourseInfo, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                course = _props.course,
	                date = _props.date;
	
	            var courseClass = (0, _classnames2.default)('rh-cardsMatrix__courseTitle', {
	                'ui-link': course.races.length > 1
	            });
	            var linkSmClass = (0, _classnames2.default)('hidden-sm-down', courseClass);
	            var linkMdClass = (0, _classnames2.default)('hidden-md-up', courseClass);
	            var courseUrl = ('/racecards/\n            ' + (date && date.length > 0 ? date + '/' : '') + '\n            #' + course.hashName).replace(/\s+/g, '');
	            var courseDetails = this.getCourseDetails(course);
	            var curseTitle = this.getCourseInfo(course);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rh-cardsMatrix__courseInfo', ref: function ref(node) {
	                        _this2.cell = node;
	                    } },
	                course.races.length === 1 ? _react2.default.createElement(
	                    'span',
	                    {
	                        className: courseClass,
	                        ref: function ref(node) {
	                            _this2.span = node;
	                        }
	                    },
	                    curseTitle
	                ) : _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: linkSmClass,
	                            href: course.meetingUrl,
	                            ref: function ref(node) {
	                                _this2.link = node;
	                            }
	                        },
	                        curseTitle
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: linkMdClass,
	                            href: courseUrl
	                        },
	                        curseTitle
	                    )
	                ),
	                !course.abandoned && courseDetails
	            );
	        }
	    }]);
	    return CourseInfo;
	}(_react.PureComponent); /**
	                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                          */
	
	exports.default = CourseInfo;

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CourseInfo = __webpack_require__(690);
	
	var _CourseInfo2 = _interopRequireDefault(_CourseInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CourseInfo module exports
	 */
	exports.default = _CourseInfo2.default; /**
	                                         * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                         */

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Race = __webpack_require__(695);
	
	var _Race2 = _interopRequireDefault(_Race);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ABANDONED = 'Abandoned';
	
	/**
	 * Component that is used for rendering course schedule
	 * @param course
	 * @param isAnchorSet
	 * @param isScrollable
	 * @constructor
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var CourseSchedule = function CourseSchedule(_ref) {
	  var course = _ref.course,
	      isAnchorSet = _ref.isAnchorSet,
	      prefTab = _ref.prefTab,
	      isScrollable = _ref.isScrollable;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'rh-cardsMatrix__races ' + (isScrollable ? 'rh-cardsMatrix__races--scrollable' : '')
	    },
	    course.abandoned ? _react2.default.createElement(
	      'span',
	      { className: 'rh-cardsMatrix__races--abandoned' },
	      ABANDONED
	    ) : course.races.map(function (race) {
	      return _react2.default.createElement(_Race2.default, {
	        key: race.id,
	        race: race,
	        isAnchorSet: isAnchorSet,
	        prefTab: prefTab,
	        racecourse: course.name
	      });
	    })
	  );
	};
	
	CourseSchedule.defaultProps = {
	  isScrollable: false
	};
	
	exports.default = CourseSchedule;

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CourseSchedule = __webpack_require__(692);
	
	var _CourseSchedule2 = _interopRequireDefault(_CourseSchedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CourseSchedule module exports
	 */
	exports.default = _CourseSchedule2.default; /**
	                                             * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                             */

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(3);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rpAnalytics = __webpack_require__(89);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering race
	 * @param race
	 * @param isAnchorSet
	 * @param colour
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var Race = function Race(_ref) {
	    var race = _ref.race,
	        isAnchorSet = _ref.isAnchorSet,
	        racecourse = _ref.racecourse,
	        prefTab = _ref.prefTab;
	    var result = race.result,
	        started = race.started,
	        isNextRace = race.isNextRace,
	        hasRaceOffers = race.hasRaceOffers,
	        link = race.link,
	        runners = race.runners,
	        id = race.id,
	        date = race.date,
	        time = race.time,
	        abandoned = race.abandoned,
	        isThirthyMinToNextRace = race.isThirthyMinToNextRace,
	        title = race.title;
	
	    var isFutureRace = !result && !started && !(isThirthyMinToNextRace && isNextRace);
	    var offersAvailable = hasRaceOffers && !result;
	    var getRaceClass = function getRaceClass() {
	        return (0, _classnames2.default)('ui-link', 'rh-cardsMatrix__race', {
	            'rh-cardsMatrix__race--result': (result || started) && !isNextRace,
	            'js-popupLink': result,
	            'rh-cardsMatrix__race--card': isFutureRace,
	            'js-navigate-url': !result && isAnchorSet,
	            'rh-cardsMatrix__race--next': isNextRace && isThirthyMinToNextRace
	        });
	    };
	    var prefLink = !result && isAnchorSet && prefTab !== 'free' ? link + '/' + prefTab : link;
	    var getLabel = function getLabel() {
	        if (result) return 'Result';
	        if (started && !isNextRace) return 'Race off';
	        return runners + ' ' + (runners > 1 ? 'runners' : 'runner');
	    };
	    var trackClick = function trackClick(e) {
	        var _segmentio$trackRaceM;
	
	        e.preventDefault();
	        segmentio.trackRaceMatrixClick((_segmentio$trackRaceM = {}, (0, _defineProperty3.default)(_segmentio$trackRaceM, segmentio.TRAIT_RACE_ID, id), (0, _defineProperty3.default)(_segmentio$trackRaceM, segmentio.TRAIT_RACE_DATE, date), (0, _defineProperty3.default)(_segmentio$trackRaceM, segmentio.TRAIT_RACE_TIME, time), (0, _defineProperty3.default)(_segmentio$trackRaceM, segmentio.TRAIT_RACECOURSE, racecourse), (0, _defineProperty3.default)(_segmentio$trackRaceM, segmentio.TRAIT_RACE_OFFERS_AVAILABLE, offersAvailable ? 'Yes' : 'No'), _segmentio$trackRaceM)).then(function () {
	            if (!result) {
	                location.href = prefLink;
	            }
	        });
	    };
	
	    return abandoned ? _react2.default.createElement(
	        'span',
	        {
	            className: 'rh-cardsMatrix__race rh-cardsMatrix__race--abandoned'
	        },
	        _react2.default.createElement(
	            'span',
	            { className: 'rh-cardsMatrix__raceTime' },
	            time
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'rh-cardsMatrix__raceLabel' },
	            'Abandoned'
	        )
	    ) : _react2.default.createElement(
	        'a',
	        {
	            href: link,
	            className: getRaceClass(),
	            title: title,
	            onClick: trackClick
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'rh-cardsMatrix__raceTimeContainer' },
	            _react2.default.createElement(
	                'span',
	                { className: 'rh-cardsMatrix__raceTime' },
	                time
	            ),
	            offersAvailable && _react2.default.createElement(
	                'span',
	                { className: 'rh-cardsMatrix__raceOfferLabel' },
	                'Offer'
	            )
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'rh-cardsMatrix__raceLabel' },
	            getLabel()
	        )
	    );
	};
	
	exports.default = Race;

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Race = __webpack_require__(694);
	
	var _Race2 = _interopRequireDefault(_Race);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Race module exports
	 */
	exports.default = _Race2.default; /**
	                                   * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                   */

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Cards = undefined;
	
	var _Cards = __webpack_require__(682);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Cards module exports
	 */
	exports.Cards = _Cards.Cards;
	exports.default = _Cards2.default; /**
	                                    * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                    */

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.News = undefined;
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(135);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _NewsStories = __webpack_require__(701);
	
	var _NewsStories2 = _interopRequireDefault(_NewsStories);
	
	var _NewsError = __webpack_require__(699);
	
	var _NewsError2 = _interopRequireDefault(_NewsError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line import/no-named-as-default
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
	    EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
	    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
	    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;
	
	var AD_POSITIONS = [{ ad: 2, position: 27, mq: [NARROW, EXTRA_NARROW, MEDIUM, WIDE, EXTRA_WIDE] }, { ad: 3, position: 45, mq: [EXTRA_NARROW] }, { ad: 4, position: 28, mq: [EXTRA_WIDE] }, { ad: 6, position: 29, mq: [EXTRA_WIDE] }, { ad: 9, position: 30, mq: [EXTRA_WIDE] }, { ad: 5, position: 31, mq: [MEDIUM, WIDE] }];
	
	/**
	 * Component that is used for rendering <News />
	 * @param storiesList
	 * @param advertisement
	 */
	function News(props) {
	  return props.storiesList.length > 0 ? _react2.default.createElement(_NewsStories2.default, (0, _extends3.default)({}, props, {
	    adPositions: AD_POSITIONS
	  })) : _react2.default.createElement(_NewsError2.default, null);
	}
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var _ref$news = _ref.news,
	      storiesList = _ref$news.storiesList,
	      advertisement = _ref$news.advertisement,
	      newsTitle = _ref.newsTitle;
	  return {
	    storiesList: storiesList,
	    advertisement: advertisement,
	    newsTitle: newsTitle
	  };
	};
	
	var ConnectedNews = (0, _reactRedux.connect)(mapStateToProps)(News);
	
	exports.News = News;
	exports.default = ConnectedNews;

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering <NewsError />
	 * It tells that some problem occurs during to retrieving news
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var NewsError = function NewsError() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'rh-news__errorsHandle ui-errorMessage' },
	        _react2.default.createElement(_rpReactSvgIcon2.default, { isInlined: true, iconName: 'results', selector: 'img-errorMessageImage' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'ui-errorMessage__container', 'data-test-selector': 'text-errorMessageText' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'ui-errorMessage__title' },
	                'Your Racing Post news service'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'ui-errorMessage__text' },
	                'There\'s a technical problem that means the news and tipping sections of racingpost.com are unavailable. We are working to resolve this and expect service to return to normal shortly. Apologies for any inconvenience this has caused.'
	            )
	        )
	    );
	};
	
	exports.default = NewsError;

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewsError = __webpack_require__(698);
	
	var _NewsError2 = _interopRequireDefault(_NewsError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * NewsError module exports
	 */
	exports.default = _NewsError2.default; /**
	                                        * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                        */

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _NewsStory = __webpack_require__(703);
	
	var _NewsStory2 = _interopRequireDefault(_NewsStory);
	
	var _Advertisement = __webpack_require__(247);
	
	var _Advertisement2 = _interopRequireDefault(_Advertisement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADVERTISEMENT = 'advertisement';
	
	/**
	 * Component that is used for rendering <NewsStories />
	 * @param storiesList
	 * @param adPositions
	 * @param advertisement
	 */
	
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var NewsStories = function (_Component) {
	    (0, _inherits3.default)(NewsStories, _Component);
	
	    function NewsStories() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, NewsStories);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewsStories.__proto__ || (0, _getPrototypeOf2.default)(NewsStories)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            currentBreakpointCode: _rpMqBreakpoints2.default.current().code
	        }, _this.setCurrentBreakpointCode = function (event) {
	            var code = event.detail.breakpoint.code;
	            _this.setState({
	                currentBreakpointCode: code
	            });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(NewsStories, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('rpBreakpointsSwitch', this.setCurrentBreakpointCode);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('rpBreakpointsSwitch', this.setCurrentBreakpointCode);
	        }
	    }, {
	        key: 'mergeNewsWithAds',
	
	
	        /**
	         * Method, used for merging news with advertisements
	         * @returns {array}
	         */
	        value: function mergeNewsWithAds() {
	            var _this2 = this;
	
	            var _props = this.props,
	                storiesList = _props.storiesList,
	                adPositions = _props.adPositions,
	                advertisement = _props.advertisement;
	
	            var mergedStories = storiesList.slice();
	
	            adPositions.forEach(function (adPosition) {
	                if (advertisement.find(function (ad) {
	                    return ad.position === adPosition.position && ad.isActive;
	                })) {
	                    var currentBreakpointCode = _this2.state.currentBreakpointCode;
	                    var isCentered = currentBreakpointCode === _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;
	                    var hidden = !adPosition.mq.includes(currentBreakpointCode);
	                    if (!hidden) {
	                        mergedStories.splice(hidden ? adPosition.ad : adPosition.ad - 1, 0, {
	                            type: ADVERTISEMENT,
	                            position: adPosition.position,
	                            hidden: hidden,
	                            isCentered: isCentered
	                        });
	                    }
	                }
	            });
	
	            return mergedStories;
	        }
	
	        /**
	         * Method, used for render news with advertisements
	         * @returns {array}
	         */
	
	    }, {
	        key: 'renderNews',
	        value: function renderNews() {
	            var mergedStories = this.mergeNewsWithAds();
	            var hiddenCounter = 0;
	
	            return mergedStories.map(function (story, index) {
	                var hidden = story.hidden,
	                    position = story.position,
	                    isCentered = story.isCentered;
	
	
	                if (hidden || position === 30) {
	                    hiddenCounter += 1;
	                }
	                var realIndex = index - hiddenCounter;
	                var odd = (realIndex + 1) % 2 ? 'odd' : 'even';
	
	                if (story.type === ADVERTISEMENT) {
	                    return _react2.default.createElement(_Advertisement2.default, {
	                        position: position,
	                        key: position,
	                        className: 'rh-newsStory ' + (hidden ? 'hidden' : odd),
	                        isCentered: isCentered
	                    });
	                }
	
	                return _react2.default.createElement(_NewsStory2.default, { story: story, key: story.id, className: odd });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Heading = this.props.newsTitle ? 'h1' : 'h2';
	            return _react2.default.createElement(
	                'section',
	                { className: 'rh-news', 'data-test-selector': 'section-news' },
	                _react2.default.createElement(
	                    Heading,
	                    { className: 'rh-newsHeader' },
	                    this.props.newsTitle || 'Today\'s highlights'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rh-newsArticles' },
	                    this.renderNews()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rh-newsButton__wrapper' },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '/news/',
	                            className: 'rh-newsButton ui-btn ui-btn_secondary', id: 'fullNewsServiceBtn'
	                        },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'rh-newsButton__label' },
	                            'Full news service'
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                adPositions: [],
	                newsTitle: '',
	                tag: ''
	            };
	        }
	    }]);
	    return NewsStories;
	}(_react.Component);
	
	exports.default = NewsStories;

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewsStories = __webpack_require__(700);
	
	var _NewsStories2 = _interopRequireDefault(_NewsStories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * NewsStories module exports
	 */
	exports.default = _NewsStories2.default; /**
	                                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                          */

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _rpReactSvgIcon = __webpack_require__(117);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _normalizeHeadingDisplay = __webpack_require__(704);
	
	var _normalizeHeadingDisplay2 = _interopRequireDefault(_normalizeHeadingDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
	    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
	    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
	    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;
	/**
	 * List of media queries
	 */
	
	var EXTRA_WIDE_MEDIA = _rpMqBreakpoints2.default.getBreakpointByCode(EXTRA_WIDE).media;
	var WIDE_MEDIA = _rpMqBreakpoints2.default.getBreakpointByCode(WIDE).media;
	var MEDIUM_MEDIA = _rpMqBreakpoints2.default.getBreakpointByCode(MEDIUM).media;
	var NARROW_MEDIA = _rpMqBreakpoints2.default.getBreakpointByCode(NARROW).media;
	var EXTRA_NARROW_MEDIA = _rpMqBreakpoints2.default.getBreakpointByCode(EXTRA_NARROW).media;
	
	/**
	 * Component that is used for rendering <NewsStory />
	 * It corrects date format, when resizing window happens
	 * It renders container correctly, when story has no image
	 */
	
	var NewsStory = function (_PureComponent) {
	    (0, _inherits3.default)(NewsStory, _PureComponent);
	
	    function NewsStory() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, NewsStory);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewsStory.__proto__ || (0, _getPrototypeOf2.default)(NewsStory)).call.apply(_ref, [this].concat(args))), _this), _this.handleResize = function (event) {
	            var breakPointCode = event.detail.breakpoint.code;
	            var _this2 = _this,
	                container = _this2.container,
	                section = _this2.section,
	                label = _this2.label;
	
	            (0, _normalizeHeadingDisplay2.default)(container, section, label, breakPointCode);
	        }, _this.renderImage = function () {
	            var story = _this.props.story;
	
	
	            return story.image && story.image.url && _react2.default.createElement(
	                'div',
	                { className: 'rh-newsStory__imageHolder sectionB__imageHolder' },
	                _react2.default.createElement(
	                    'picture',
	                    { className: 'rh-newsStory__picture' },
	                    _react2.default.createElement('source', {
	                        srcSet: story.image['data-src-' + EXTRA_WIDE],
	                        media: EXTRA_WIDE_MEDIA
	                    }),
	                    _react2.default.createElement('source', {
	                        srcSet: story.image['data-src-' + WIDE],
	                        media: WIDE_MEDIA
	                    }),
	                    _react2.default.createElement('source', {
	                        srcSet: story.image['data-src-' + MEDIUM],
	                        media: MEDIUM_MEDIA
	                    }),
	                    _react2.default.createElement('source', {
	                        srcSet: story.image['data-src-' + NARROW],
	                        media: NARROW_MEDIA
	                    }),
	                    _react2.default.createElement('source', {
	                        srcSet: story.image['data-src-' + EXTRA_NARROW],
	                        media: EXTRA_NARROW_MEDIA
	                    }),
	                    _react2.default.createElement('img', {
	                        className: 'rh-newsStory__image',
	                        src: story.image.url,
	                        alt: story.image.altText || ''
	                    })
	                )
	            );
	        }, _this.renderIcon = function () {
	            var story = _this.props.story;
	
	            var isImagePresent = story.image.url;
	            var storyClassName = (0, _classnames2.default)('rh-newsStory__icon', isImagePresent ? 'rh-newsStory__iconPremContent' : 'rh-newsStory__iconPremContent_noImg');
	
	            return !story.isLive && story.image && !story.isFree && _react2.default.createElement(_rpReactSvgIcon2.default, {
	                isInlined: true,
	                size: 'Medium',
	                iconName: 'subscribe',
	                className: storyClassName
	            });
	        }, _this.renderVideoIcon = function () {
	            var story = _this.props.story;
	
	
	            return !story.isLive && story.videoIncluded && _react2.default.createElement(_rpReactSvgIcon2.default, {
	                size: 'Medium',
	                iconName: 'videoHollow',
	                className: 'rh-newsStory__icon rh-newsStory__iconVideo labelMedia__icon'
	            });
	        }, _this.renderAudioIcon = function () {
	            var story = _this.props.story;
	
	
	            return !story.isLive && story.audioIncluded && _react2.default.createElement(_rpReactSvgIcon2.default, {
	                size: 'Medium',
	                iconName: 'audio',
	                className: 'rh-newsStory__icon rh-newsStory__iconAudio labelMedia__icon'
	            });
	        }, _this.renderLiveIcon = function () {
	            var story = _this.props.story;
	
	
	            return story.isLive && _react2.default.createElement(
	                'span',
	                { className: 'story__live' },
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    size: 'Large',
	                    iconName: 'news-live-no-fill',
	                    className: 'newsLiveIcon'
	                })
	            );
	        }, _this.renderLiveLabel = function () {
	            var story = _this.props.story;
	
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'rh-newsStory__live storyLabel_live' },
	                story.liveLabel ? story.liveLabel : 'LIVE',
	                '\xA0'
	            );
	        }, _this.renderLiveUnderlay = function () {
	            var story = _this.props.story;
	
	
	            return story.isLive && _react2.default.createElement('div', { className: 'rh-newsStory_liveUnderlay' });
	        }, _this.renderSection = function () {
	            var story = _this.props.story;
	
	
	            return story.section && _react2.default.createElement(
	                'span',
	                {
	                    className: 'rh-newsStory__section storyLabel',
	                    ref: function ref(node) {
	                        _this.section = node;
	                    }
	                },
	                story.isLive && _this.renderLiveLabel(),
	                story.section + ' '
	            );
	        }, _this.renderLabel = function () {
	            var story = _this.props.story;
	
	
	            return story.label && _react2.default.createElement(
	                'span',
	                { className: 'rh-newsStory__label storyLabel', ref: function ref(node) {
	                        _this.label = node;
	                    } },
	                story.label
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(NewsStory, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var story = this.props.story;
	
	
	            if (!story.isLive) {
	                var breakPointCode = _rpMqBreakpoints2.default.current();
	                var container = this.container,
	                    section = this.section,
	                    label = this.label,
	                    handleResize = this.handleResize;
	
	                (0, _normalizeHeadingDisplay2.default)(container, section, label, breakPointCode);
	                window.addEventListener('rpBreakpointsSwitch', handleResize);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var handleResize = this.handleResize;
	
	            window.removeEventListener('rpBreakpointsSwitch', handleResize);
	        }
	
	        /**
	         * Method, which is triggered, while screen is resizing
	         */
	
	
	        /**
	         * Method is used for rendering image
	         */
	
	
	        /**
	         * Method is used for rendering icon
	         */
	
	
	        /**
	         * Method is used for rendering icon with video
	         */
	
	
	        /**
	         * Method is used for rendering icon with audio
	         */
	
	
	        /**
	         * Method is used for rendering icon and label for live blog
	         */
	
	
	        /**
	         * Method is used for rendering live label for live blog
	         */
	
	
	        /**
	         * Method for rendering Underlay
	         */
	
	
	        /**
	         * Method for rendering section
	         */
	
	
	        /**
	         * Method for rendering label
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var story = this.props.story;
	            var renderImage = this.renderImage,
	                renderIcon = this.renderIcon,
	                renderSection = this.renderSection,
	                renderLabel = this.renderLabel,
	                renderVideoIcon = this.renderVideoIcon,
	                renderAudioIcon = this.renderAudioIcon,
	                renderLiveUnderlay = this.renderLiveUnderlay,
	                renderLiveIcon = this.renderLiveIcon;
	
	
	            var isImagePresent = Boolean(story.image.url);
	            var headlineHolderClass = (0, _classnames2.default)('rh-newsStory__headlineHolder', 'sectionB__headline', 'headline', { 'rh-newsStory__headlineHolder_noImg': !isImagePresent });
	            var storyClasses = (0, _classnames2.default)('sectionB', 'rh-newsStory', this.props.className, { 'rh-newsStory_live': story.isLive });
	
	            var renderHeadlineHolder = function renderHeadlineHolder() {
	                return _react2.default.createElement(
	                    'div',
	                    { className: headlineHolderClass },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'rh-newsStory__sectionWrapper',
	                            ref: function ref(node) {
	                                _this3.container = node;
	                            }
	                        },
	                        renderIcon(),
	                        renderLiveIcon(),
	                        _react2.default.createElement(
	                            'span',
	                            { className: (0, _classnames2.default)({ 'rh-newsStory__topic': story.isLive }) },
	                            renderSection(),
	                            renderLabel()
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'rh-newsStory__headline headline' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'rh-newsStory__iconWrp' },
	                            renderVideoIcon(),
	                            renderAudioIcon()
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'rh-newsStory__headline-title' },
	                            story.headline
	                        )
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'a',
	                { href: story.url, className: storyClasses },
	                renderImage(),
	                renderHeadlineHolder(),
	                renderLiveUnderlay()
	            );
	        }
	    }], [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                className: ''
	            };
	        }
	    }]);
	    return NewsStory;
	}(_react.PureComponent);
	
	/**
	 * Module exports
	 */
	
	
	exports.default = NewsStory;

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewsStory = __webpack_require__(702);
	
	var _NewsStory2 = _interopRequireDefault(_NewsStory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * <NewsStory /> module exports
	 */
	exports.default = _NewsStory2.default; /**
	                                        * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                        */

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
	    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
	    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
	    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE; /**
	                                                               * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                                               */
	
	var ICON_SMALL = 24,
	    ICON_MEDIUM = 32,
	    ICON_LARGE = 64;
	
	/**
	 * Function, that returns proper icon size regarding on breakPointCode
	 * @param breakPointCode
	 * @returns {*|number}
	 */
	
	var getIconSize = function getIconSize(breakPointCode) {
	    switch (breakPointCode) {
	        case EXTRA_NARROW:
	            return ICON_SMALL;
	        case NARROW:
	        case MEDIUM:
	        case WIDE:
	            return ICON_MEDIUM;
	        case EXTRA_WIDE:
	            return ICON_LARGE;
	        default:
	            return ICON_SMALL;
	    }
	};
	
	/**
	 * Function, that sets proper display to block
	 * @param container
	 * @param section
	 * @param label
	 * @param breakPointCode
	 * @returns {boolean}
	 */
	var normalizeHeadingDisplay = function normalizeHeadingDisplay(container, section, label, breakPointCode) {
	    if (!(container && section && label)) {
	        return false;
	    }
	
	    var iconSize = getIconSize(breakPointCode);
	    var computedStyle = getComputedStyle(container);
	
	    var containerWidth = container.clientWidth;
	    containerWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
	
	    [section, label].forEach(function (element) {
	        if (element.offsetWidth + iconSize >= containerWidth) {
	            element.style.display = 'block'; // eslint-disable-line no-param-reassign
	        }
	    });
	
	    return true;
	};
	
	exports.default = normalizeHeadingDisplay;

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.News = undefined;
	
	var _News = __webpack_require__(697);
	
	var _News2 = _interopRequireDefault(_News);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * News module exports
	 */
	exports.News = _News.News;
	exports.default = _News2.default; /**
	                                   * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                   */

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(138);
	
	function storiesList() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.stories;
	
	    return state;
	} /**
	   * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	   */
	
	
	function advertisement() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.__PRELOADED_STATE.advertisement;
	
	    return state;
	}
	
	/**
	 * News reducer
	 * @param state
	 * @returns {Array}
	 */
	
	exports.default = (0, _redux.combineReducers)({
	    storiesList: storiesList,
	    advertisement: advertisement
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(94);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(93);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpPricesComponent = __webpack_require__(1524);
	
	var _rpRaceDayLive = __webpack_require__(1531);
	
	var _BetslipInteracter = __webpack_require__(714);
	
	var _BetslipInteracter2 = _interopRequireDefault(_BetslipInteracter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering <RacedayLive />
	 */
	var RacedayLive = function (_PureComponent) {
	    (0, _inherits3.default)(RacedayLive, _PureComponent);
	
	    function RacedayLive() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RacedayLive);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RacedayLive.__proto__ || (0, _getPrototypeOf2.default)(RacedayLive)).call.apply(_ref, [this].concat(args))), _this), _this.RDL = new _rpRaceDayLive.RaceDayLive(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RacedayLive, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                maximumTopicsInList = _props.maximumTopicsInList,
	                adaptForExNarrowLayout = _props.adaptForExNarrowLayout,
	                buttonOnlyAtTop = _props.buttonOnlyAtTop;
	
	
	            new _rpPricesComponent.BestOdds(); // eslint-disable-line no-new
	            new _rpPricesComponent.BetHandler(); // eslint-disable-line no-new
	            _rpPricesComponent.priceButton.activate();
	
	            this.RDL.init({
	                maximumTopicsInList: maximumTopicsInList,
	                adaptForExNarrowLayout: adaptForExNarrowLayout,
	                buttonOnlyAtTop: buttonOnlyAtTop
	            });
	
	            var betslipInteracter = new _BetslipInteracter2.default();
	            betslipInteracter.init().then(function (betslipFeedName) {
	                return _rpPricesComponent.pricesProvider.init(betslipFeedName);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'rh-racedayLive' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rh-racedayLive__title' },
	                    'Raceday live'
	                ),
	                _react2.default.createElement('div', {
	                    className: 'rh-racedayLive__list rdl-content js-diffusionTopicSettingsRace',
	                    id: 'rdl-content'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rh-racedayLive__footer' },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: 'news/live',
	                            className: 'rh-racedayLive__button ui-btn ui-btn_secondary'
	                        },
	                        'Full live service'
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                maximumTopicsInList: 4,
	                adaptForExNarrowLayout: true,
	                buttonOnlyAtTop: true
	
	            };
	        }
	    }]);
	    return RacedayLive;
	}(_react.PureComponent); /**
	                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                          */
	
	exports.default = RacedayLive;

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RacedayLive = __webpack_require__(707);
	
	var _RacedayLive2 = _interopRequireDefault(_RacedayLive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * <RacedayLive /> module exports
	 */
	exports.default = _RacedayLive2.default; /**
	                                          * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                          */

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(22);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdvertisementList = __webpack_require__(676);
	
	var _AdvertisementList2 = _interopRequireDefault(_AdvertisementList);
	
	var _BookmakerRegPanel = __webpack_require__(398);
	
	var _BookmakerRegPanel2 = _interopRequireDefault(_BookmakerRegPanel);
	
	var _contentHubHelper = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that is used for rendering <Sidebar />
	 * It consists of:
	 * <BookmakerRegPanelContainer />
	 * <AdvertisementList />
	 */
	/**
	 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	 */
	
	function Sidebar() {
	    return _react2.default.createElement(
	        'aside',
	        { className: 'ui-sidebar ui-sidebar_paddingless ui-sidebar_marginless' },
	        (0, _contentHubHelper.checkForRegPanel)() && _react2.default.createElement(_BookmakerRegPanel2.default, null),
	        _react2.default.createElement(_AdvertisementList2.default, null)
	    );
	}
	
	exports.default = Sidebar;

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Sidebar = __webpack_require__(709);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sidebar module exports
	 */
	exports.default = _Sidebar2.default; /**
	                                      * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	                                      */

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPageSection = undefined;
	
	var _defineProperty2 = __webpack_require__(3);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.default = analyticsPage;
	
	var _rpAnalytics = __webpack_require__(89);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sectionDefault = 'Homepage';
	var sections = {
	    homepage: sectionDefault,
	    'cheltenham-festival': 'Cheltenham festival',
	    'the-derby': 'The derby',
	    'grand-national': 'Grand national',
	    'champions-day': 'Champions day',
	    'royal-ascot': 'Royal ascot',
	    'glorious-goodwood': 'Glorious goodwood',
	    'breeders-cup': 'Breeders cup',
	    '1000-guineas': '1,000 Guineas',
	    '2000-guineas': '2,000 Guineas',
	    'melbourne-cup': 'Melbourne cup',
	    pools: 'Tote Pools',
	    'ten-to-follow': 'Ten To Follow Competition'
	};
	
	var getPageSection = exports.getPageSection = function getPageSection() {
	    var pathnameSplit = window.location.pathname.split('/');
	    var page = pathnameSplit[1];
	    var pageSection = !page || !sections[page] ? sectionDefault : sections[page];
	
	    return pageSection;
	};
	
	function analyticsPage() {
	    var _segmentio$setCommonT;
	
	    var newSection = getPageSection();
	
	    segmentio.setCommonTraits((_segmentio$setCommonT = {}, (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, newSection), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, null), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, null), _segmentio$setCommonT));
	
	    segmentio.page();
	}

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(138);
	
	var _reduxDevtoolsExtension = __webpack_require__(1388);
	
	var _reduxThunk = __webpack_require__(1393);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(1392);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _rootReducer = __webpack_require__(713);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Function, that configures store and initial state
	 * Adds logger as middleware in development environment
	 * @param preloadedState
	 */
	var configureStore = function configureStore(preloadedState) {
	    var middleware = [_reduxThunk2.default];
	    var logger = (0, _reduxLogger2.default)();
	    var composeEnhancers = _redux.compose;
	
	    if (false) {
	        middleware.push(logger);
	        composeEnhancers = _reduxDevtoolsExtension.composeWithDevTools;
	    }
	
	    return (0, _redux.createStore)(_rootReducer2.default, preloadedState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middleware)));
	}; /**
	    * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	    */
	
	exports.default = configureStore;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReducers = undefined;
	
	var _redux = __webpack_require__(138);
	
	var _cards = __webpack_require__(683);
	
	var _cards2 = _interopRequireDefault(_cards);
	
	var _news = __webpack_require__(706);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _bookmakers = __webpack_require__(681);
	
	var _bookmakers2 = _interopRequireDefault(_bookmakers);
	
	var _panelTemplate = __webpack_require__(680);
	
	var _panelTemplate2 = _interopRequireDefault(_panelTemplate);
	
	var _advertisement = __webpack_require__(674);
	
	var _advertisement2 = _interopRequireDefault(_advertisement);
	
	var _contentHubHelper = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Root reducer of application
	 * It combines:
	 * - Cards reducer (optional)
	 * - News reducer
	 * - Bookmakers reducer
	 * - Advertisement reducer
	 * - Content Hub reducer
	 */
	var getReducers = exports.getReducers = function getReducers() {
	  var reducers = {
	    news: _news2.default,
	    bookmakers: _bookmakers2.default,
	    panelTemplate: _panelTemplate2.default,
	    advertisement: _advertisement2.default,
	    newsTitle: _contentHubHelper.getNewsTitle
	  };
	
	  /**
	   * Cards section absent at Content Hub pages
	   */
	  if (!(0, _contentHubHelper.isContentHubPage)()) {
	    reducers.cards = _cards2.default;
	  }
	
	  return reducers;
	}; /**
	    * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
	    */
	
	exports.default = (0, _redux.combineReducers)(getReducers());

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetslipInteracter = function () {
	    function BetslipInteracter() {
	        (0, _classCallCheck3.default)(this, BetslipInteracter);
	
	        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
	        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
	        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
	        this.init = this.init.bind(this);
	        this.decimalOdds = false;
	    }
	
	    (0, _createClass3.default)(BetslipInteracter, [{
	        key: 'init',
	        value: function init(feedName) {
	            var deferred = _jquery2.default.Deferred();
	            this.resolvePromise = deferred.resolve;
	            var customizeSettingsCookie = _jquery2.default.cookie('customizeSettings');
	            if (customizeSettingsCookie) {
	                var customizeSettings = JSON.parse(customizeSettingsCookie);
	                this.decimalOdds = customizeSettings.decimalOdds;
	            }
	            this.bindEvents();
	            if (feedName) {
	                this.feedName = feedName;
	                this.setBetslipBookmaker(feedName);
	            } else {
	                this.requestSelectedBookmaker();
	            }
	            return deferred.promise();
	        }
	    }, {
	        key: 'onBookmakerChanged',
	        value: function onBookmakerChanged(_ref) {
	            var bookmaker = _ref.detail.bookmaker;
	
	            (0, _jquery2.default)(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
	            this.resolveBookmaker(bookmaker);
	        }
	    }, {
	        key: 'resolveBookmaker',
	        value: function resolveBookmaker(bookmaker) {
	            if (this.resolvePromise) {
	                this.resolvePromise(bookmaker);
	                this.resolvePromise = null;
	                delete this.resolvePromise;
	            }
	        }
	    }, {
	        key: 'onBetslipInitialized',
	        value: function onBetslipInitialized() {
	            if (this.feedName) {
	                this.setBetslipBookmaker(this.feedName);
	                this.resolveBookmaker(this.feedName);
	            } else {
	                this.requestSelectedBookmaker();
	            }
	        }
	
	        /* eslint-disable class-methods-use-this */
	
	    }, {
	        key: 'requestSelectedBookmaker',
	        value: function requestSelectedBookmaker() {
	            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
	            document.dispatchEvent(betslipEvent);
	        }
	
	        /* eslint-disable class-methods-use-this */
	
	    }, {
	        key: 'setBetslipBookmaker',
	        value: function setBetslipBookmaker(bookmaker) {
	            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
	                detail: { bookmaker: bookmaker }
	            });
	            document.dispatchEvent(betslipEvent);
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
	            document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
	            document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
	            document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
	            document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
	        }
	    }]);
	    return BetslipInteracter;
	}(); /* eslint-disable import/no-extraneous-dependencies */
	
	
	exports.default = BetslipInteracter;

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(736), __esModule: true };

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(739), __esModule: true };

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(740), __esModule: true };

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(773);
	module.exports = __webpack_require__(27).Object.getPrototypeOf;


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(774);
	module.exports = __webpack_require__(27).Object.setPrototypeOf;


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(776);
	__webpack_require__(417);
	__webpack_require__(780);
	__webpack_require__(781);
	module.exports = __webpack_require__(27).Symbol;


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(183);
	__webpack_require__(184);
	module.exports = __webpack_require__(263).f('iterator');


/***/ }),

/***/ 744:
[1651, 146, 256, 147],

/***/ 748:
[1652, 143],

/***/ 753:
[1653, 182, 82, 95, 83, 118],

/***/ 757:
[1655, 97, 407],

/***/ 758:
[1657, 47, 27, 118],

/***/ 761:
[1658, 82, 62, 144, 406],

/***/ 773:
[1661, 260, 408, 758],

/***/ 774:
[1662, 47, 761],

/***/ 776:
[1663, 41, 95, 81, 47, 412, 753, 118, 258, 181, 182, 42, 263, 262, 744, 748, 62, 82, 97, 261, 180, 255, 757, 406, 83, 146, 407, 147, 256, 145, 96],

/***/ 780:
[1664, 262],

/***/ 781:
[1665, 262],

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1121:
1120,

/***/ 1122:
1120,

/***/ 1123:
1120,

/***/ 1124:
1120,

/***/ 1125:
1120,

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      var compose = __webpack_require__(138).compose;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);


/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(623);
	
	var _diff = __webpack_require__(1391);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(974);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(1389);
	
	var _helpers = __webpack_require__(623);
	
	var _defaults = __webpack_require__(1390);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),

/***/ 1398:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var requestIdleCallback =
	  function (cb) {
	  if (global.requestIdleCallback) return global.requestIdleCallback(cb)
	    var start = Date.now();
	    return setTimeout(function () {
	      cb({
	        didTimeout: false,
	        timeRemaining: function () {
	          return Math.max(0, 50 - (Date.now() - start));
	        }
	      });
	    }, 1);
	  }
	
	var cancelIdleCallback =
	  function (id) {
	  if (global.cancelIdleCallback) return global.cancelIdleCallback(id)
	    return clearTimeout(id);
	  }
	
	exports.requestIdleCallback = requestIdleCallback
	exports.cancelIdleCallback = cancelIdleCallback
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(89));
		else if(typeof define === 'function' && define.amd)
			define(["rp-analytics"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = initBookmakerRegPanel;
	
	var _rpAnalytics = __webpack_require__(1);
	
	var SegmentIO = _interopRequireWildcard(_rpAnalytics);
	
	__webpack_require__(0);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function initBookmakerRegPanel() {
	    var openedBookmakerClass = 'rh-bookmaker--open';
	    var hiddenPanelClass = 'rh-bookmakers--hidden';
	    var isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
	
	    if (isMobile) {
	        Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
	            return webBookmakersNode.remove();
	        });
	    }
	
	    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmakers__heading--mobile')).forEach(function (mobileHeaderNode) {
	        return mobileHeaderNode.addEventListener('click', function () {
	            var bookmakersNode = mobileHeaderNode.parentNode.parentNode;
	
	            if (bookmakersNode.classList.contains(hiddenPanelClass)) {
	                bookmakersNode.classList.remove(hiddenPanelClass);
	
	                SegmentIO.trackOfferAccordionOpened(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));
	
	                return;
	            }
	
	            bookmakersNode.classList.add(hiddenPanelClass);
	
	            SegmentIO.trackOfferAccordionClosed(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));
	        });
	    });
	
	    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).forEach(function (headerNode) {
	        return headerNode.addEventListener('click', function () {
	            var _SegmentIO$trackOffer4;
	
	            var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
	            var bookmakerNode = headerNode.parentNode;
	            var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
	            var index = Number(bookmakerNode.getAttribute('data-index')) + 1;
	
	            if (openedBookmakerNodes.length > 0) {
	                Array.from(openedBookmakerNodes).forEach(function (node) {
	                    var offerLabel = node.querySelector('.rh-bookmaker__view-offer>span');
	                    offerLabel.innerHTML = 'View offer';
	                    node.classList.remove(openedBookmakerClass);
	                });
	            }
	
	            if (!isBookmakerNodeOpened) {
	                var _SegmentIO$trackOffer3;
	
	                bookmakerNode.classList.add(openedBookmakerClass);
	                SegmentIO.trackOfferAccordionOpened((_SegmentIO$trackOffer3 = {}, _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer3));
	                bookmakerNode.querySelector('.rh-bookmaker__view-offer>span').innerHTML = 'Hide offer';
	
	                return;
	            }
	
	            SegmentIO.trackOfferAccordionClosed((_SegmentIO$trackOffer4 = {}, _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer4));
	        });
	    });
	
	    Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn')).forEach(function (el) {
	        return el.addEventListener('click', function () {
	            var _SegmentIO$trackBetti;
	
	            SegmentIO.trackBettingOfferClick((_SegmentIO$trackBetti = {}, _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_BOOKMAKER, el.getAttribute('data-name')), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_LOCATION, 'Panel'), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_POSITION, Number(el.getAttribute('data-index')) + 1), _SegmentIO$trackBetti));
	        });
	    });
	}
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=rpbettingspecialoffer.js.map

/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rpMqBreakpoints = __webpack_require__(38);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _rpDiffusionConnector = __webpack_require__(212);
	
	var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _DIFFUSION = __webpack_require__(238);
	
	var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);
	
	var _EVENTS = __webpack_require__(638);
	
	var _EVENTS2 = _interopRequireDefault(_EVENTS);
	
	var _PopOver2 = __webpack_require__(640);
	
	var _PopOver3 = _interopRequireDefault(_PopOver2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var narrowBreakpoints = [_rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.NARROW];
	
	var BestOddsPopOver = function (_PopOver) {
	    _inherits(BestOddsPopOver, _PopOver);
	
	    function BestOddsPopOver() {
	        _classCallCheck(this, BestOddsPopOver);
	
	        return _possibleConstructorReturn(this, (BestOddsPopOver.__proto__ || Object.getPrototypeOf(BestOddsPopOver)).apply(this, arguments));
	    }
	
	    _createClass(BestOddsPopOver, [{
	        key: 'open',
	        value: function open(e) {
	            var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	            if (currentBookmaker !== '#BESTODDS') {
	                return;
	            }
	            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'open', this).call(this, e);
	            (0, _jquery2.default)(window).on(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
	            (0, _jquery2.default)(window).on(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
	        }
	    }, {
	        key: 'close',
	        value: function close(e) {
	            (0, _jquery2.default)(window).off(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
	            (0, _jquery2.default)(window).off(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
	            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'close', this).call(this, e);
	        }
	    }]);
	
	    return BestOddsPopOver;
	}(_PopOver3.default);
	
	var defaultConfig = {
	    bestOddsContainerSelector: '.js-bestOddsPriceContainer',
	    diffusionConfigs: '.js-diffusionHorsesList',
	    priceBtnOddsSelector: '.js-PC-bestOdds__priceBtn',
	    activeBestOddsSelector: {
	        popOver: '.js-PC-bestOdds',
	        horseList: '.js-diffusionBestOdds',
	        arrow: '.js-PC-bestOdds__arrow'
	    },
	    bestOddsArrowHiddenClass: 'PC-bestOdds__arrow_hidden',
	    bestOddsArrowRight: 'PC-bestOdds__arrow_right',
	    bestOddsArrowLeft: 'PC-bestOdds__arrow_left',
	    noPointerClass: 'RC-runnerPrice_noPointer',
	    bestOddsArrowHeight: 27,
	    sideMarginInPx: 16,
	    bestOddsArrowPositionInPx: {
	        min: 7,
	        max: 488
	    },
	    popOverConfig: {
	        activeClass: 'PC-bestOdds_active',
	        popOverSelector: '.js-PC-bestOdds',
	        openAreaSelector: '.js-runnerPriceBestOdds',
	        shadowAreaSelectors: '.PC-bestOddsOverlay',
	        diffusionConfig: '.js-diffusionBestOdds',
	        runnerName: '.js-bestOddsHorseName'
	    }
	};
	
	var BestOdds = function () {
	    function BestOdds(config) {
	        _classCallCheck(this, BestOdds);
	
	        this.config = _jquery2.default.extend(true, defaultConfig, config);
	        this.init();
	    }
	
	    _createClass(BestOdds, [{
	        key: 'init',
	        value: function init() {
	            this.diffusionSession = new _rpDiffusionConnector2.default({
	                onDataFunction: this.onDataReceive.bind(this)
	            });
	
	            this.showDecimalPrices = false;
	            this.initOverlay();
	            this.bindEvents();
	            this.$bestOdds = (0, _jquery2.default)(this.config.popOverConfig.popOverSelector);
	            this.$bestOddsParent = this.$bestOdds.parent();
	            this.initPopover();
	        }
	    }, {
	        key: 'initOverlay',
	        value: function initOverlay() {
	            this.overlay = (0, _jquery2.default)('<div class="PC-bestOddsOverlay"></div>');
	            (0, _jquery2.default)('body').append(this.overlay);
	        }
	    }, {
	        key: 'initPopover',
	        value: function initPopover() {
	            var popoverOptions = this.getPopoverOptions();
	            this.popOver = new BestOddsPopOver(popoverOptions);
	        }
	    }, {
	        key: 'getPopoverOptions',
	        value: function getPopoverOptions() {
	            return {
	                activeClass: this.config.popOverConfig.activeClass,
	                popOverSelector: this.config.popOverConfig.popOverSelector,
	                openAreaSelectors: [this.config.popOverConfig.openAreaSelector],
	                closeAreaSelectors: [this.config.priceBtnOddsSelector, this.config.popOverConfig.shadowAreaSelectors],
	                onOpen: this.onPopOverOpen.bind(this),
	                onClose: this.onPopOverClose.bind(this),
	                onResizeHandler: this.onResizeHandler.bind(this),
	                onBreakpointChange: this.onBreakpointChange.bind(this)
	            };
	        }
	    }, {
	        key: 'onPopOverOpen',
	        value: function onPopOverOpen(e) {
	            this.overlay.show();
	            this.prepareDiffusionData(e);
	            this.pricesSubscribe();
	            this.setOriginPrice(e.target);
	            this.handleBestOddsPosition();
	        }
	    }, {
	        key: 'onPopOverClose',
	        value: function onPopOverClose() {
	            this.diffusionSession.unsubscribeAll();
	            this.clearPopUp();
	            this.overlay.hide();
	            this.$bestOdds.detach();
	            this.$bestOddsParent.append(this.$bestOdds);
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
	            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicsRunnersUpdate.bind(this));
	            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onDynamicsRunnersUpdate.bind(this));
	        }
	    }, {
	        key: 'onUserSettingsChanged',
	        value: function onUserSettingsChanged(event, userSettings) {
	            this.showDecimalPrices = userSettings.decimalOdds;
	        }
	    }, {
	        key: 'onDynamicsRunnersUpdate',
	        value: function onDynamicsRunnersUpdate() {
	            this.popOver.destroy();
	            this.initPopover();
	        }
	    }, {
	        key: 'onDataReceive',
	        value: function onDataReceive(webClientMessage) {
	            var topic = webClientMessage.getTopic();
	
	            if (topic.includes('#INFO')) {
	                this.handleRaceInfo(webClientMessage);
	            } else {
	                this.handleHorsePrice(webClientMessage);
	            }
	        }
	    }, {
	        key: 'prepareDiffusionData',
	        value: function prepareDiffusionData(event) {
	            var $diffusionHorseListElem = (0, _jquery2.default)(event.target).closest(this.config.diffusionConfigs);
	            var diffusionHorseName = $diffusionHorseListElem.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
	            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate($diffusionHorseListElem);
	            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime($diffusionHorseListElem);
	            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName($diffusionHorseListElem);
	
	            (0, _jquery2.default)(this.config.popOverConfig.runnerName).text(diffusionHorseName);
	            var $diffusionBestOdds = (0, _jquery2.default)(this.config.popOverConfig.diffusionConfig);
	            this.$bestOdds.detach();
	
	            $diffusionBestOdds.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, diffusionHorseName).attr(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, courseName).attr(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, raceTime).attr(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, raceDate);
	
	            var $priceContainer = (0, _jquery2.default)(event.target).closest(this.config.bestOddsContainerSelector);
	            $priceContainer.append(this.$bestOdds);
	        }
	    }, {
	        key: 'handleRaceInfo',
	        value: function handleRaceInfo(WebClientMessage) {
	            var raceInfo = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);
	
	            this.renderEwInfo(raceInfo);
	            _PricesStateStore.pricesStateStore.updateRaceInfo(raceInfo);
	            if (raceInfo.suspendState === 'H') {
	                this.updatePricesForRaceInfo(raceInfo.bookmaker);
	            }
	        }
	    }, {
	        key: 'handleHorsePrice',
	        value: function handleHorsePrice(WebClientMessage) {
	            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);
	
	            this.renderPrice(renderConfig);
	        }
	    }, {
	        key: 'renderPrice',
	        value: function renderPrice(renderConfig) {
	            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
	             * support CSS selector search with data attributes
	             */
	
	            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig}"]`;
	            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
	            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
	            var bookieContainer = Array.prototype.filter.call(pricesContainer, function (el) {
	                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
	            });
	            var priceButton = (0, _jquery2.default)(bookieContainer).find(this.config.priceBtnOddsSelector)[0];
	
	            this.clearBestOddsPosition();
	
	            if (priceButton) {
	                var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);
	                priceButton.innerHTML = renderPriceValue;
	                if (renderPriceValue === '-') {
	                    priceButton.classList.add(this.config.noPointerClass);
	                } else {
	                    priceButton.classList.remove(this.config.noPointerClass);
	                }
	                var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
	                var dataDiffusionStatus = raceInfo && raceInfo.suspendState === 'H' ? 'H' : renderConfig.status;
	
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, renderConfig.outcomersId);
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, renderConfig.fractionalPrice);
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, renderConfig.decimalPrice);
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.STATUS, dataDiffusionStatus);
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, renderConfig.eventId);
	                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, renderConfig.meetingId);
	
	                bookieContainer[0].classList.add('PC-bestOdds__bookieRow_active');
	                this.sortPrices(bookieContainer);
	            }
	            this.handleBestOddsPosition();
	        }
	    }, {
	        key: 'sortPrices',
	        value: function sortPrices(bookieRow) {
	            var bookieContainer = (0, _jquery2.default)(bookieRow).closest('.PC-bestOdds__bookiesList').find('.PC-bestOdds__bookieRow_active');
	
	            if (bookieContainer.length === 0) {
	                return;
	            }
	            var priceBtnOddsSelector = this.config.priceBtnOddsSelector;
	            bookieContainer.toArray().map(function (item) {
	                return {
	                    bookie: item.getAttribute('data-diffusion-bookieName').toLowerCase(),
	                    price: (0, _jquery2.default)(item).find(priceBtnOddsSelector).attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
	                    element: item
	                };
	            }).sort(function (prev, next) {
	                if (isNaN(prev.price) && isNaN(next.price) || prev.price === next.price) {
	                    if (prev.bookie > next.bookie) {
	                        return 1;
	                    } else if (prev.bookie < next.bookie) {
	                        return -1;
	                    }
	                    return 0;
	                } else if (isNaN(prev.price)) {
	                    return 1;
	                } else if (isNaN(next.price)) {
	                    return 0;
	                }
	                return next.price - prev.price;
	            }).forEach(function (elem, index) {
	                var bookieElement = elem.element;
	                bookieElement.style.order = index;
	            });
	        }
	    }, {
	        key: 'pricesSubscribe',
	        value: function pricesSubscribe() {
	            var horsesList = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList).toArray();
	            var topics = horsesList.map(function (horseElement) {
	                var bookmaker = _DiffusionServiceUtils.diffusionServiceUtils.getTopicBookmaker(horseElement);
	                var diffusionData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(horseElement);
	
	                return _extends(diffusionData, { bookmaker: bookmaker });
	            }).map(function (diffusionData) {
	                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(diffusionData);
	                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic(diffusionData);
	
	                return [priceTopic, infoTopic];
	            }).reduce(function (acum, value) {
	                return acum.concat(value);
	            }, []).filter(function (topic) {
	                return topic;
	            });
	
	            this.diffusionSession.subscribe({ topics: topics });
	        }
	    }, {
	        key: 'renderEwInfo',
	        value: function renderEwInfo(renderConfig) {
	            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
	             * support CSS selector search with data attributes
	             */
	
	            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig.bookmaker}"]`;
	
	            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
	            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
	            var bookieContainer = (0, _jquery2.default)(Array.prototype.filter.call(pricesContainer, function (el) {
	                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
	            }));
	            var ewElement = bookieContainer.find('.js-diffusionBestOdds_eachWay')[0];
	            var bogElement = bookieContainer.find('.js-diffusionBestOdds_bog')[0];
	
	            if (ewElement) {
	                ewElement.innerHTML = renderConfig.isWinOnly ? '<b>win only</b>' : [renderConfig.winOdds, renderConfig.placeWinner].join(' ');
	            }
	
	            if (bogElement) {
	                if (renderConfig.isBog === 'Y') {
	                    bogElement.classList.add('PC-bestOdds__bookieRow__oddsIcon_active');
	                } else {
	                    bogElement.classList.remove('PC-bestOdds__bookieRow__oddsIcon_active');
	                }
	            }
	        }
	    }, {
	        key: 'clearPopUp',
	        value: function clearPopUp() {
	            var _this2 = this;
	
	            var diffusionRows = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList);
	
	            Array.prototype.forEach.call(diffusionRows, function (element) {
	                var priceBtn = (0, _jquery2.default)(element).find(_this2.config.priceBtnOddsSelector)[0];
	
	                element.classList.remove('PC-bestOdds__bookieRow_active');
	
	                _this2.renderEwInfo({
	                    winOdds: '',
	                    placeWinner: '',
	                    isBog: 'N',
	                    bookmaker: element.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER)
	                });
	                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, '');
	                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, '');
	                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, '');
	                priceBtn.innerHTML = '';
	            });
	        }
	    }, {
	        key: 'handleBestOddsPosition',
	        value: function handleBestOddsPosition() {
	            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0];
	            var popOverArrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
	            var windowHeight = window.innerHeight;
	            var windowWidth = window.innerWidth;
	            var bestOddsRect = popOver.getBoundingClientRect();
	            var bestOddsArrowPositionMax = bestOddsRect.height - this.config.bestOddsArrowHeight;
	            var $priceContainer = (0, _jquery2.default)(this.originPrice).closest(this.config.bestOddsContainerSelector);
	            var priceContainerRect = $priceContainer.length ? $priceContainer[0].getBoundingClientRect() : null;
	            var originPriceRect = this.originPrice.getBoundingClientRect();
	            var targetContainerRect = priceContainerRect && priceContainerRect.width && priceContainerRect.height > originPriceRect.height ? priceContainerRect : originPriceRect;
	            var isWideBreakpoint = narrowBreakpoints.indexOf(_rpMqBreakpoints2.default.current().code) === -1;
	
	            var calculatedTop = -(bestOddsRect.height - targetContainerRect.height) / 2;
	            var spaceToTop = targetContainerRect.top + calculatedTop;
	            var spaceToBottom = windowHeight - (targetContainerRect.top + calculatedTop + bestOddsRect.height);
	            var calculatedLeft = void 0;
	
	            // Vertical Alignment
	
	            if (spaceToTop < this.config.sideMarginInPx && spaceToBottom > this.config.sideMarginInPx) {
	                calculatedTop = this.config.sideMarginInPx - targetContainerRect.top;
	            } else if (spaceToBottom < this.config.sideMarginInPx && spaceToTop > this.config.sideMarginInPx) {
	                calculatedTop = windowHeight - targetContainerRect.top - bestOddsRect.height - this.config.sideMarginInPx;
	            }
	            var arrowTop = -(calculatedTop - (targetContainerRect.height - this.config.bestOddsArrowHeight) / 2);
	
	            // Arrow alignment
	            if (arrowTop < this.config.bestOddsArrowPositionInPx.min || arrowTop > bestOddsArrowPositionMax) {
	                popOverArrow.classList.add(this.config.bestOddsArrowHiddenClass);
	            } else {
	                popOverArrow.setAttribute('style', 'top:' + arrowTop + 'px');
	            }
	            // Horizontal alignment
	
	            if (isWideBreakpoint) {
	                calculatedLeft = targetContainerRect.width + 16;
	            } else {
	                calculatedLeft = (windowWidth - bestOddsRect.width) / 2 - targetContainerRect.left;
	            }
	
	            if (windowWidth < targetContainerRect.left + calculatedLeft + bestOddsRect.width + this.config.sideMarginInPx && isWideBreakpoint) {
	                calculatedLeft = -(bestOddsRect.width + 16);
	                popOverArrow.classList.add(this.config.bestOddsArrowRight);
	            } else {
	                popOverArrow.classList.add(this.config.bestOddsArrowLeft);
	            }
	
	            if (calculatedLeft) {
	                popOver.setAttribute('style', 'top:' + calculatedTop + 'px; left:' + calculatedLeft + 'px');
	            } else {
	                popOver.setAttribute('style', 'top:' + calculatedTop + 'px');
	            }
	        }
	    }, {
	        key: 'clearBestOddsPosition',
	        value: function clearBestOddsPosition() {
	            var arrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
	            arrow.setAttribute('style', '');
	            arrow.classList.remove(this.config.bestOddsArrowHiddenClass);
	            arrow.classList.remove(this.config.bestOddsArrowRight);
	            arrow.classList.remove(this.config.bestOddsArrowLeft);
	
	            (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0].setAttribute('style', '');
	        }
	    }, {
	        key: 'onResizeHandler',
	        value: function onResizeHandler() {
	            this.clearBestOddsPosition();
	            this.handleBestOddsPosition();
	        }
	    }, {
	        key: 'onBreakpointChange',
	        value: function onBreakpointChange() {
	            this.popOver.close();
	        }
	    }, {
	        key: 'updatePricesForRaceInfo',
	        value: function updatePricesForRaceInfo(bookmaker) {
	            var _this3 = this;
	
	            var bookieElements = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver).find(this.config.popOverConfig.diffusionConfig).toArray();
	
	            bookieElements.filter(function (el) {
	                return el.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER) === bookmaker;
	            }).map(function (el) {
	                return (0, _jquery2.default)(el).find(_this3.config.priceBtnOddsSelector)[0];
	            }).forEach(function (el) {
	                var priceInfo = _this3.getRenderConfigFromElement(el);
	                var getRaceInfo = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(el);
	                var renderConfig = _extends(priceInfo, getRaceInfo, { bookmaker: bookmaker });
	                // TODO: clear is some esear way (JIRA: PC-4557)
	                _this3.renderPrice(renderConfig);
	            });
	        }
	        // TODO: move to private function or to utils (JIRA: PC-4559)
	        /* eslint-disable class-methods-use-this */
	
	    }, {
	        key: 'getRenderConfigFromElement',
	        value: function getRenderConfigFromElement(element) {
	            return {
	                outcomersId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID),
	                fractionalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL),
	                decimalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
	                historyPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.HISTORY),
	                eventId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID),
	                meetingId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID)
	            };
	        }
	        /* eslint-enable class-methods-use-this */
	
	    }, {
	        key: 'setOriginPrice',
	        value: function setOriginPrice(newPrice) {
	            this.originPriceElement = newPrice;
	        }
	    }, {
	        key: 'originPrice',
	        get: function get() {
	            return this.originPriceElement;
	        }
	    }]);
	
	    return BestOdds;
	}();
	
	exports.default = BestOdds;

/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jsCookie = __webpack_require__(162);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _rpAnalytics = __webpack_require__(89);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	var _ToteBookmakersNameMap = __webpack_require__(1529);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _DIFFUSION = __webpack_require__(238);
	
	var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var nonIntegratedBookieList = {
	    'SPORTING INDEX': {
	        url: 'https://sports.sportingbet.com/en/sports/racing?wm=4582140#racing=lobby',
	        width: 572,
	        height: 523,
	        name: 'SPORTING INDEX'
	    },
	    BOLEYSPORTS: {
	        url: 'http://www.boylesports.com/addbet?idfiacampaign=32667&id=[$outcomeId]',
	        width: 1000,
	        height: 600,
	        name: 'BOLEYSPORTS'
	    },
	    '888': {
	        url: 'https://www.888sport.com/?sr=1644587',
	        width: 1000,
	        height: 600,
	        name: '888'
	    },
	    VC: {
	        url: 'http://www.betvictor.com/sports/en/coupon/remotes?outcomeids=[[$outcomeId]00]&btagid=90081080',
	        width: 986,
	        height: 600,
	        name: 'VC'
	    },
	    TOTE: {
	        url: 'https://tote.co.uk/[$meeting-name]/[$time]/[$runner-name]/win?utm_source=racingpost&utm_medium=partner-editoral&utm_campaign=oddsgrid&utm_content=odds-grid',
	        width: 1050,
	        height: 500,
	        name: 'TOTE'
	    }
	};
	
	var bookmakersMap = {
	    BET365: 'bet365',
	    LADB: 'Ladbrokes',
	    WH_OXI: 'William Hill',
	    CORAL: 'Coral',
	    PPWR: 'Paddy Power',
	    BETFAIR: 'Betfair',
	    'SPORTING INDEX': 'Sporting',
	    VC: 'BetVictor',
	    SURREY: 'Sky bet',
	    BOLEYSPORTS: 'Boylesport',
	    '888': '888sport',
	    TOTE: 'Tote',
	    '#BESTODDS': 'Best Odds'
	};
	
	var LOCATION_DATA_ATTRIBUTE = 'data-price-location';
	var RACE_ID_DATA_ATTRIBUTE = 'data-diffusion-race-id';
	var DATA_RACE_DATE_TIME = 'data-card-race-date-time';
	
	function isPriceButtonClicked($priceElement) {
	    var invalidPricePattern = /^[\s,\-,NR]{1,}$/;
	    return $priceElement.length && !$priceElement.text().match(invalidPricePattern);
	}
	
	function getBookmakerName($priceElement) {
	    var bookieRow = $priceElement.closest('[' + _DIFFUSION2.default.DATA.INPUT.BOOKMAKER + ']')[0];
	    if (bookieRow) {
	        var bookmaker = bookieRow.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER);
	        if (bookmaker) {
	            return bookmaker;
	        }
	    }
	    return _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	}
	
	function isBookmakerIntegrated(bookmakerName) {
	    return !!nonIntegratedBookieList[bookmakerName];
	}
	
	function setLocationfromURL() {
	    var location = window.location.href;
	    if (location.indexOf('horse-tracker') > -1) return 'Horse Tracker';
	
	    if (location.indexOf('profile') > -1) {
	        if (location.indexOf('horse') > -1) return 'Horse Profile';
	        if (location.indexOf('jockey') > -1) return 'Jockey Profile';
	        if (location.indexOf('owner') > -1) return 'Owner Profile';
	        if (location.indexOf('trainer') > -1) return 'Trainer Profile';
	    }
	
	    if (location.indexOf('tipping') > -1) return 'Tipping Article';
	    if (location.indexOf('news') > -1) return 'News Article';
	
	    return 'Undefined location';
	}
	
	function trackBetButtonClickAnalytics(bookieName, location, selectionData) {
	    var _config;
	
	    var bookmaker = Object.prototype.hasOwnProperty.call(bookmakersMap, bookieName) ? bookmakersMap[bookieName] : bookieName;
	    var trackLocation = void 0;
	
	    if (location) {
	        trackLocation = location;
	    } else {
	        trackLocation = setLocationfromURL();
	    }
	
	    var config = (_config = {}, _defineProperty(_config, segmentio.TRAIT_LOCATION, trackLocation), _defineProperty(_config, segmentio.TRAIT_BOOKMAKER, bookmaker), _defineProperty(_config, segmentio.TRAIT_PRICE, selectionData.priceType), _defineProperty(_config, segmentio.TRAIT_HORSE_NAME, selectionData.horseName), _config);
	
	    segmentio.identify(undefined, config).then(function () {
	        return segmentio.trackBetButtonClick(config);
	    });
	}
	
	/* eslint-disable class-methods-use-this */
	
	var BetHandler = function () {
	    function BetHandler() {
	        _classCallCheck(this, BetHandler);
	
	        this.bindEvents();
	    }
	
	    _createClass(BetHandler, [{
	        key: 'bindEvents',
	        value: function bindEvents() {
	            var $body = (0, _jquery2.default)('body');
	
	            $body[0].addEventListener('click', this.makeSelectionHandler.bind(this), true);
	            $body.on('RC.makeSelection', this.makeSelection.bind(this));
	        }
	    }, {
	        key: 'makeSelectionHandler',
	        value: function makeSelectionHandler(event) {
	            var $priceElement = (0, _jquery2.default)(event.target).closest('.js-betHandler');
	            if (!isPriceButtonClicked($priceElement)) {
	                return;
	            }
	            event.preventDefault();
	
	            var horseElement = $priceElement.closest('.js-diffusionHorsesList')[0] || $priceElement.closest('.js-diffusionBestOdds')[0];
	            var raceId = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(RACE_ID_DATA_ATTRIBUTE, horseElement);
	
	            if (!raceId) {
	                // eslint-disable-next-line no-console
	                console.error('Making selection required parameter missing');
	                return;
	            }
	
	            var id = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID);
	            var fractionalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);
	            var decimalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL);
	            var isSp = fractionalPrice === 'SP';
	            var price = isSp ? null : fractionalPrice;
	            var eventId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID);
	            var meetingId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID);
	            var bookmaker = getBookmakerName($priceElement);
	
	            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName(horseElement);
	            var horseName = horseElement.getAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
	            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime(horseElement);
	            var dataRaceDateTime = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_RACE_DATE_TIME, horseElement);
	            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate(horseElement);
	            var location = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(LOCATION_DATA_ATTRIBUTE, horseElement);
	            var userMD5 = _jsCookie2.default.get('RP_MD5_COOKIE');
	            var topic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
	                courseName: courseName,
	                raceTime: raceTime,
	                raceDate: raceDate,
	                bookmaker: bookmaker
	            });
	
	            var getCourseName = courseName.toUpperCase();
	            var getToteCourseName = getCourseName in _ToteBookmakersNameMap.toteCourseNameMapping ? _ToteBookmakersNameMap.toteCourseNameMapping[getCourseName] : courseName;
	            var ToteTimeObj = new Date(dataRaceDateTime);
	            var formatMinutes = ToteTimeObj.getMinutes() < 10 ? "0" + ToteTimeObj.getMinutes() : ToteTimeObj.getMinutes();
	            var setToteRaceTime = ToteTimeObj.getHours() + ":" + formatMinutes;
	
	            var selectionData = {
	                selectionInfo: {
	                    id: id,
	                    price: price,
	                    fractionalPrice: fractionalPrice,
	                    decimalPrice: decimalPrice,
	                    isSp: isSp,
	                    eventId: eventId,
	                    meetingId: meetingId,
	                    data: {
	                        horseName: horseName,
	                        courseName: courseName.toLowerCase(),
	                        raceDate: raceDate,
	                        time: raceTime,
	                        eachWayTopic: topic,
	                        infoTopic: topic,
	                        raceId: raceId
	                    },
	                    toteUrlParams: {
	                        horseName: horseName.replace(/[\W_]/g, '-').toLowerCase(),
	                        courseName: getToteCourseName.replace(/[\W_]/g, '-').toLowerCase(),
	                        time: setToteRaceTime
	                    }
	                },
	                bookieName: bookmaker,
	                userMD5: userMD5,
	                priceElement: $priceElement
	            };
	            this.makeSelection(event, selectionData);
	
	            if ((0, _jquery2.default)(event.target).hasClass('added-to-betslip')) {
	                var priceType = isSp ? 'SP' : 'Odds';
	
	                trackBetButtonClickAnalytics(bookmaker, location, {
	                    priceType: priceType,
	                    horseName: horseName
	                });
	            }
	        }
	    }, {
	        key: 'onNotIntegratedBookmakerSelected',
	        value: function onNotIntegratedBookmakerSelected(data) {
	            var bookieName = data.bookieName,
	                _data$selectionInfo = data.selectionInfo,
	                id = _data$selectionInfo.id,
	                price = _data$selectionInfo.price,
	                isSp = _data$selectionInfo.isSp,
	                priceElement = data.priceElement;
	
	            var notIntegratedBookmaker = nonIntegratedBookieList[bookieName];
	            var outcomersId = notIntegratedBookmaker.name === 'BOLEYSPORTS' ? id / 10 : id;
	            var dividend = '';
	            var divider = '';
	            if (!isSp) {
	                var splitedPrice = price.split('/');
	                dividend = splitedPrice[0];
	                divider = splitedPrice[1];
	            }
	
	            var toteHorseName = data.selectionInfo.toteUrlParams.horseName;
	            var toteCorseName = data.selectionInfo.toteUrlParams.courseName;
	            var toteRaceTime = data.selectionInfo.toteUrlParams.time;
	            var isOddsComparisonTable = window.location.href.split('/').indexOf('odds-comparison') > 0;
	
	            // tote replacing are [$meeting-name]/[$time]/[$runner-name]/win'
	
	            var url = notIntegratedBookmaker.url.replace('[$runner-name]', toteHorseName).replace('[$time]', toteRaceTime).replace('[$meeting-name]', toteCorseName).replace('[$outcomeId]', outcomersId).replace('[$dividend]', dividend).replace('[$divider]', divider).replace('[$price]', data.selectionInfo.price || '').replace('[$userMD5]', !data.userMD5 ? 'no_MD5_cookie' : data.userMD5).replace('[$eventId]', data.selectionInfo.eventId).replace('[$meetingId]', data.selectionInfo.meetingId).replace('[$utm_content]', isOddsComparisonTable ? 'oddscomparison' : 'racecardsodds');
	
	            priceElement.attr('href', url).attr('data-popup-width', notIntegratedBookmaker.width).attr('data-popup-height', notIntegratedBookmaker.height).attr('data-popup-blank', true).addClass('js-popupLink');
	        }
	    }, {
	        key: 'onIntegratedBookmakerSelected',
	        value: function onIntegratedBookmakerSelected(data) {
	            var bookieName = data.bookieName,
	                _data$selectionInfo2 = data.selectionInfo,
	                meetingId = _data$selectionInfo2.meetingId,
	                _data$selectionInfo2$ = _data$selectionInfo2.data,
	                courseName = _data$selectionInfo2$.courseName,
	                raceDate = _data$selectionInfo2$.raceDate,
	                time = _data$selectionInfo2$.time;
	
	            var _pricesStateStore$get = _PricesStateStore.pricesStateStore.getRaceInfo({
	                bookmaker: bookieName,
	                courseName: courseName.toUpperCase(),
	                raceDate: raceDate,
	                raceTime: time
	            }),
	                suspendState = _pricesStateStore$get.suspendState,
	                winOdds = _pricesStateStore$get.winOdds,
	                placeWinner = _pricesStateStore$get.placeWinner,
	                isBog = _pricesStateStore$get.isBog;
	
	            _extends(data.selectionInfo, {
	                suspendState: suspendState,
	                eachWayFraction: winOdds,
	                eachWayPlaces: placeWinner,
	                isBog: isBog
	            });
	            var raceId = data.selectionInfo.data.raceId;
	            var outcomersId = data.selectionInfo.id;
	
	            if (window.betslipApi && window.betslipApi.isHorseSelected(raceId, outcomersId, meetingId)) {
	                var removeSelectionEvent = new CustomEvent('BETSLIP.REMOVE_SELECTION', { detail: data });
	                document.dispatchEvent(removeSelectionEvent);
	                // for back compatibility (temporary)
	                _jquery2.default.event.trigger('BETSLIP.REMOVE_SELECTION', _extends({}, data));
	            } else {
	                var makeSelectionEvent = new CustomEvent('BETSLIP.MAKE_SELECTION', { detail: data });
	                document.dispatchEvent(makeSelectionEvent);
	                // for back compatibility (temporary)
	                _jquery2.default.event.trigger('BETSLIP.MAKE_SELECTION', _extends({}, data));
	            }
	        }
	    }, {
	        key: 'makeSelection',
	        value: function makeSelection(event, data) {
	            var bookieName = data.bookieName;
	
	            if (isBookmakerIntegrated(bookieName)) {
	                this.onNotIntegratedBookmakerSelected(data);
	            } else if (data.bookieName !== '#BESTODDS') {
	                this.onIntegratedBookmakerSelected(data);
	            }
	        }
	    }]);
	
	    return BetHandler;
	}();
	/* eslint-enable class-methods-use-this */
	
	exports.default = BetHandler;

/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.pricesStateStore = exports.horsesListStore = exports.diffusionServiceUtils = exports.pricesProvider = exports.priceButton = exports.PRICE_HANDLER_EVENTS = exports.BestOdds = exports.PopOver = exports.BetHandler = undefined;
	
	__webpack_require__(1124);
	
	var _PopOver = __webpack_require__(640);
	
	var _PopOver2 = _interopRequireDefault(_PopOver);
	
	var _BestOdds = __webpack_require__(1522);
	
	var _BestOdds2 = _interopRequireDefault(_BestOdds);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	var _BetHandler = __webpack_require__(1523);
	
	var _BetHandler2 = _interopRequireDefault(_BetHandler);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _HorsesListStore = __webpack_require__(639);
	
	var _priceButtonPresenter = __webpack_require__(1525);
	
	var _PricesProvider = __webpack_require__(637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BetHandler = _BetHandler2.default;
	exports.PopOver = _PopOver2.default;
	exports.BestOdds = _BestOdds2.default;
	exports.PRICE_HANDLER_EVENTS = _PricesProvider.PRICE_HANDLER_EVENTS;
	exports.priceButton = _priceButtonPresenter.priceButton;
	exports.pricesProvider = _PricesProvider.pricesProvider;
	exports.diffusionServiceUtils = _DiffusionServiceUtils.diffusionServiceUtils;
	exports.horsesListStore = _HorsesListStore.horsesListStore;
	exports.pricesStateStore = _PricesStateStore.pricesStateStore;

/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.priceButton = exports.PRICE_BUTTON = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _DiffusionServiceUtils = __webpack_require__(141);
	
	var _DIFFUSION = __webpack_require__(238);
	
	var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);
	
	var _PricesStateStore = __webpack_require__(140);
	
	var _PricesProvider = __webpack_require__(637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRICE_BUTTON = exports.PRICE_BUTTON = {
	    CLASSES: {
	        SUBSCRIBED: 'js-PC-subscribed',
	        NOT_SUBSCRIBED: '.js-diffusionHorsesList:not(.js-PC-subscribed)',
	        NOT_CLICKABLE: 'noPointerClass',
	        HIDDEN: 'ui-priceBtn_noPrice'
	    },
	    SELECTORS: {
	        RACE_SETTINGS: '.js-diffusionTopicSettingsRace', // General container
	        HORSE_ELEMENT: '.js-diffusionHorsesList', // Div with particular price
	        PRICE_VALUE: '.js-diffusionPriceValue' // <a> with data from diffusion
	    },
	    POPUP: {
	        HEIGHT: 'data-popup-height',
	        WIDTH: 'data-popup-width',
	        BLANK: 'data-popup-blank',
	        LINK_CLASS: 'js-popupLink'
	    },
	    BOOKMAKERS: {
	        WH_OXI: 'ui-priceBtn_williamHill',
	        '#BESTODDS': 'ui-priceBtn_bestOdds',
	        LADB: 'ui-priceBtn_ladbrokes',
	        BET365: 'ui-priceBtn_bet365',
	        CORAL: 'ui-priceBtn_coral',
	        PPWR: 'ui-priceBtn_paddypower',
	        BETFAIR: 'ui-priceBtn_betfair',
	        VC: 'ui-priceBtn_betVictor',
	        'SPORTING INDEX': 'ui-priceBtn_sportingBet',
	        SURREY: 'ui-priceBtn_skybet',
	        '888': 'ui-priceBtn_888sport',
	        BOLEYSPORTS: 'ui-priceBtn_boylesport',
	        TOTE: 'ui-priceBtn_tote'
	    }
	};
	
	/* eslint-disable no-use-before-define */
	var priceButton = exports.priceButton = {
	    activate: activate,
	    deactivate: deactivate
	};
	
	function activate() {
	    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
	    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
	    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
	    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
	    addBetslipEventListeners();
	}
	
	function deactivate() {
	    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
	    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
	    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
	    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
	}
	
	function onPriceReceived(renderConfig) {
	    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	    if (currentBookmaker === renderConfig.bookmaker) {
	        renderPrice(renderConfig);
	    }
	}
	
	function onPriceSettingsChanged(_ref) {
	    var showDecimal = _ref.showDecimal;
	
	    togglePricesViewType({ showDecimal: showDecimal });
	}
	
	function onPricesWillBeUpdated() {
	    clearPrices();
	}
	
	function addBetslipEventListeners() {
	    document.addEventListener('BETSLIP.SELECTION_MADE', function () {
	        setAddedToBetslipClass();
	    });
	
	    document.addEventListener('BETSLIP.SELECTION_REMOVED', function () {
	        setAddedToBetslipClass();
	    });
	}
	
	function onRaceInfoReceived(_ref2) {
	    var bookmaker = _ref2.bookmaker,
	        courseName = _ref2.courseName,
	        raceDate = _ref2.raceDate,
	        raceTime = _ref2.raceTime,
	        suspendState = _ref2.suspendState;
	
	    if (suspendState === 'H') {
	        markPricesOfFinishedRaces({ bookmaker: bookmaker, courseName: courseName, raceDate: raceDate, raceTime: raceTime });
	    }
	}
	
	function markPricesOfFinishedRaces(_ref3) {
	    var bookmaker = _ref3.bookmaker,
	        courseName = _ref3.courseName,
	        raceDate = _ref3.raceDate,
	        raceTime = _ref3.raceTime;
	
	    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();
	    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
	
	    if (bookmaker !== currentBookmaker) {
	        return;
	    }
	    priceElements.filter(function (priceElement) {
	        var elementData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(priceElement);
	
	        return elementData.courseName === courseName && elementData.raceDate === raceDate && elementData.raceTime === raceTime;
	    }).forEach(function (priceElement) {
	        var element = priceElement;
	
	        element.innerHTML = '-';
	        element.classList.add(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
	    });
	}
	
	function togglePricesViewType(_ref4) {
	    var showDecimal = _ref4.showDecimal;
	
	    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();
	
	    priceElements.forEach(togglePriceViewType);
	
	    function togglePriceViewType(priceElement) {
	        var element = priceElement;
	        var currentValue = priceElement.innerHTML;
	        var isNoPrice = ['', '-', 'SP'].includes(currentValue);
	
	        if (!isNoPrice) {
	            element.innerHTML = showDecimal ? Math.floor(parseFloat(priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL)) * 100) / 100 : priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);
	
	            if (_DIFFUSION2.default.DATA.INPUT.BOOKMAKER === 'TOTE') {
	                element.innerHTML = parseFloat(element.innerHTML).toFixed(2);
	            }
	        }
	    }
	}
	
	function renderPrice(renderConfig) {
	    var priceElements = _DiffusionServiceUtils.diffusionServiceUtils.getPriceContainer(renderConfig);
	
	    priceElements.forEach(function (buttonContainer) {
	        var priceElement = (0, _jquery2.default)(buttonContainer).find(PRICE_BUTTON.SELECTORS.PRICE_VALUE)[0];
	        var $priceElement = (0, _jquery2.default)(priceElement);
	        var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);
	
	        if (priceElement) {
	            applyButtonStyling($priceElement, renderPriceValue, renderConfig.bookmaker);
	
	            setDiffusionDataAttributes($priceElement, _extends(renderConfig, { nextPrice: renderPriceValue }));
	            $priceElement.text(renderPriceValue);
	        }
	    });
	
	    setAddedToBetslipClass();
	}
	
	function clearPrices() {
	    (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray().forEach(function (priceElement) {
	        var element = priceElement;
	
	        element.innerHTML = '';
	        setDiffusionDataAttributes(element, {});
	        clearBookmakerStyling(element);
	    });
	}
	
	function setAddedToBetslipClass() {
	    var nextSelections = !!window.betslipApi && window.betslipApi.getSelectedBets();
	    (0, _jquery2.default)('.added-to-betslip').removeClass('added-to-betslip');
	    if (nextSelections.length) {
	        nextSelections.forEach(function (selection) {
	            var $priceElements = (0, _jquery2.default)('[data-diffusion-outcomers-id="' + selection.outcomersId + '"][data-diffusion-meeting-id="' + selection.meetingId + '"]');
	            if ($priceElements.length) {
	                $priceElements.addClass('added-to-betslip');
	            }
	        });
	    }
	}
	
	function setDiffusionDataAttributes(element, priceConfig) {
	    (0, _jquery2.default)(element).attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, priceConfig.outcomersId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, priceConfig.fractionalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, priceConfig.decimalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.HISTORY, priceConfig.historyPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.STATUS, priceConfig.status || '').attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, priceConfig.eventId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, priceConfig.meetingId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.NEXT_PRICE, priceConfig.nextPrice || '').attr(PRICE_BUTTON.POPUP.WIDTH, '').attr(PRICE_BUTTON.POPUP.HEIGHT, '').attr('href', '#');
	}
	
	function clearBookmakerStyling(element) {
	    var $element = (0, _jquery2.default)(element);
	
	    $element.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
	    Object.keys(PRICE_BUTTON.BOOKMAKERS).forEach(function (feed) {
	        $element.removeClass(PRICE_BUTTON.BOOKMAKERS[feed]);
	    });
	}
	
	function applyButtonStyling($priceElement, renderPriceValue, bookmaker) {
	    $priceElement.removeClass(PRICE_BUTTON.POPUP.LINK_CLASS);
	
	    if (renderPriceValue) {
	        if (renderPriceValue === '-') {
	            $priceElement.addClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
	        } else {
	            $priceElement.removeClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
	        }
	        $priceElement.removeClass(PRICE_BUTTON.CLASSES.HIDDEN).addClass(PRICE_BUTTON.BOOKMAKERS[bookmaker]);
	    } else {
	        $priceElement.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
	    }
	}

/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DiffusionFeedHelper = function () {
	    function DiffusionFeedHelper() {
	        _classCallCheck(this, DiffusionFeedHelper);
	
	        this.bookmakerFeedConfig = [{ bookmaker: 'PPWR', feed: 'PADDYPOWER' }, { bookmaker: 'BETFAIR', feed: 'BETFAIR' }, { bookmaker: 'WH_OXI', feed: 'WH_OXI' }, { bookmaker: 'LADB', feed: 'LADB' }, { bookmaker: 'BET365', feed: 'BET365' }, { bookmaker: 'CORAL', feed: 'CORAL' }, { bookmaker: 'BOLEYSPORTS', feed: 'BOLEYSPORTS' }, { bookmaker: 'RB', feed: 'RB' }, { bookmaker: 'SPORTING INDEX', feed: 'SPORTING INDEX' }, { bookmaker: 'SURREY', feed: 'SURREY' }, { bookmaker: '888', feed: '888' }, { bookmaker: 'VC', feed: 'VC' }, { bookmaker: 'TOTE', feed: 'TOTE' }];
	    }
	
	    _createClass(DiffusionFeedHelper, [{
	        key: 'getFeedByBookmaker',
	        value: function getFeedByBookmaker(bookmaker) {
	            var found = this.bookmakerFeedConfig.find(function (item) {
	                return item.bookmaker === bookmaker;
	            });
	            return found ? found.feed : bookmaker;
	        }
	    }, {
	        key: 'getBookmakerByFeed',
	        value: function getBookmakerByFeed(feed) {
	            var found = this.bookmakerFeedConfig.find(function (item) {
	                return item.feed === feed;
	            });
	            return found ? found.bookmaker : feed;
	        }
	    }]);
	
	    return DiffusionFeedHelper;
	}();
	
	exports.default = new DiffusionFeedHelper();

/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.prepareTopics = exports.combineArrays = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _requestIdleCallback = __webpack_require__(1398);
	
	var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// [a, b] + [c, d, e] = [ a, c, b, d, e ]
	var combineArrays = exports.combineArrays = function combineArrays(first, second) {
	    var result = [];
	    while (first.length > 0 || second.length > 0) {
	        if (first.length > 0) {
	            result.push(first.shift());
	        }
	        if (second.length > 0) {
	            result.push(second.shift());
	        }
	    }
	
	    return result;
	};
	
	// in order to subscribe for prices in both columns in parallel.
	var prepareTopics = exports.prepareTopics = function prepareTopics(topics) {
	    var preparedTopics = [];
	    if ((0, _jquery2.default)(document).width() < 768) {
	        preparedTopics = Array.from(topics);
	    } else {
	        var center = topics.findIndex(function (topic) {
	            return topic.indexOf && topic.indexOf('WIN/M') > -1;
	        });
	        preparedTopics = combineArrays(topics.slice(0, center), topics.slice(center));
	    }
	
	    return preparedTopics;
	};
	
	var Subscriber = function () {
	    function Subscriber(session) {
	        var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	        _classCallCheck(this, Subscriber);
	
	        this.taskList = [];
	        this.isActive = false;
	        this.session = session;
	        this.currentTaskId = 0;
	        this.chunkSize = chunkSize;
	        this.runTask = this.runTask.bind(this);
	    }
	
	    _createClass(Subscriber, [{
	        key: 'run',
	        value: function run() {
	            this.isActive = true;
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.isActive = false;
	        }
	    }, {
	        key: 'addTask',
	        value: function addTask(taskHandler, taskData) {
	            this.taskList.push({
	                handler: taskHandler,
	                data: taskData
	            });
	
	            if (!this.currentTaskId) {
	                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
	            }
	        }
	    }, {
	        key: 'runTask',
	        value: function runTask(deadline) {
	            while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length && this.isActive) {
	                var task = this.taskList.shift();
	                task.handler(task.data);
	            }
	
	            if (this.taskList.length) {
	                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
	            } else {
	                this.currentTaskId = 0;
	            }
	        }
	    }, {
	        key: 'schedule',
	        value: function schedule(topics) {
	            var _this = this;
	
	            var chunks = [];
	            var preparedTopics = prepareTopics(topics);
	
	            for (var i = 0; i < topics.length; i += this.chunkSize) {
	                chunks.push(preparedTopics.slice(i, i + this.chunkSize));
	            }
	
	            chunks.forEach(function (chunk) {
	                _this.addTask(_this.session.subscribe, { topics: chunk });
	            });
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe(topics) {
	            if (!this.session || !topics.map) {
	                return;
	            }
	
	            if (topics.length <= this.chunkSize) {
	                this.session.subscribe({ topics: topics });
	            } else {
	                this.schedule(topics);
	            }
	        }
	    }, {
	        key: 'unsubscribeAll',
	        value: function unsubscribeAll() {
	            this.stop();
	            this.taskList = [];
	            _requestIdleCallback2.default.cancelIdleCallback(this.currentTaskId);
	            this.currentTaskId = 0;
	            this.session.unsubscribeAll();
	            this.run();
	        }
	    }]);
	
	    return Subscriber;
	}();
	
	exports.default = Subscriber;

/***/ }),

/***/ 1528:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PubSub = function () {
	    function PubSub() {
	        _classCallCheck(this, PubSub);
	
	        this.handlers = [];
	    }
	
	    _createClass(PubSub, [{
	        key: "subscribe",
	        value: function subscribe(event, handler) {
	            this.handlers.push({ event: event, handler: handler });
	        }
	    }, {
	        key: "unsubscribe",
	        value: function unsubscribe(event, handler) {
	            this.handlers = this.handlers.filter(function (savedHandler) {
	                return !(savedHandler.event === event && savedHandler.handler === handler);
	            });
	        }
	    }, {
	        key: "publish",
	        value: function publish(event, args) {
	            this.handlers.filter(function (topic) {
	                return topic.event === event;
	            }).forEach(function (topic) {
	                return topic.handler(args);
	            });
	        }
	    }]);
	
	    return PubSub;
	}();
	
	exports.default = PubSub;

/***/ }),

/***/ 1529:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var toteCourseNameMapping = exports.toteCourseNameMapping = {
	    "ASCOT": "ASCOT",
	    "AYR": "AYR",
	    "BANGOR-ON-DEE": "BANGOR",
	    "CARLISLE": "CARLISLE",
	    "CATTERICK": "CATTERICK",
	    "CHELMSFORD": "CHELMSFORD CITY",
	    "CHELMSFORD (A.W)": "CHELMSFORD CITY",
	    "CHELTENHAM": "CHELTENHAM",
	    "CHEPSTOW": "CHEPSTOW",
	    "CLONMEL": "CLONMEL",
	    "CORK": "CORK",
	    "DONCASTER": "DONCASTER",
	    "DOWN ROYAL": "DOWN ROYAL",
	    "DOWNPATRICK": "DOWNPATRICK",
	    "DUNDALK (A.W)": "DUNDALK",
	    "EXETER": "EXETER",
	    "FAIRYHOUSE": "FAIRYHOUSE",
	    "FAKENHAM": "FAKENHAM",
	    "FFOS LAS": "FFOS LAS",
	    "FONTWELL": "FONTWELL",
	    "GOWRAN PARK": "GOWRAN",
	    "HAYDOCK": "HAYDOCK PARK",
	    "HEREFORD": "HEREFORD",
	    "HEXHAM": "HEXHAM",
	    "HUNTINGDON": "HUNTINGDON",
	    "KELSO": "KELSO",
	    "KEMPTON": "KEMPTON PARK",
	    "KEMPTON (A.W)": "KEMPTON PARK",
	    "LEICESTER": "LEICESTER",
	    "LEOPARDSTOWN": "LEOPARDSTOWN",
	    "LIMERICK": "LIMERICK",
	    "LINGFIELD": "LINGFIELD PARK",
	    "LINGFIELD (A.W)": "LINGFIELD PARK",
	    "LUDLOW": "LUDLOW",
	    "MARKET RASEN": "MARKET RASEN",
	    "MUSSELBURGH": "MUSSELBURGH",
	    "NAAS": "NAAS",
	    "NAVAN": "NAVAN",
	    "NEWBURY": "NEWBURY",
	    "NEWCASTLE": "NEWCASTLE",
	    "NEWCASTLE (A.W)": "NEWCASTLE",
	    "PLUMPTON": "PLUMPTON",
	    "PUNCHESTOWN": "PUNCHESTOWN",
	    "RIPON": "RIPON",
	    "SEDGEFIELD": "SEDGEFIELD",
	    "SOUTHWELL": "SOUTHWELL",
	    "SOUTHWELL (A.W)": "SOUTHWELL",
	    "STRATFORD": "STRATFORD",
	    "TAUNTON": "TAUNTON",
	    "THURLES": "THURLES",
	    "TRAMORE": "TRAMORE",
	    "UTTOXETER": "UTTOXETER",
	    "WARWICK": "WARWICK",
	    "WETHERBY": "WETHERBY",
	    "WEXFORD": "WEXFORD",
	    "WINCANTON": "WINCANTON",
	    "WOLVERHAMPTON (A.W)": "WOLVERHAMPTON"
	};

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rpDiffusionConnector = __webpack_require__(212);
	
	var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RdlDiffusion = function RdlDiffusion($, options) {
	
	    var config = $.extend({
	        topicName: '',
	        callbackLE: function callbackLE() {}
	    }, options);
	
	    var sessionConfig = {
	        onCallbackFunction: function onCallbackFunction() {},
	        onDataFunction: onDataReceive
	    };
	
	    var session = new _rpDiffusionConnector2.default(sessionConfig);
	
	    session.subscribe({ topic: config.topicName });
	
	    function onDataReceive(WebClientMessage) {
	        if (WebClientMessage.topic === 'LIVE_EVENT/1') {
	            config.callbackLE(WebClientMessage.records[0].fields[0], WebClientMessage.records[0].fields[1]);
	        }
	    }
	
	    return session;
	};
	
	exports.default = RdlDiffusion;

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RdlDiffusion = exports.RdlTemplates = exports.RaceDayLive = undefined;
	
	var _templates = __webpack_require__(1532);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _diffusion = __webpack_require__(1530);
	
	var _diffusion2 = _interopRequireDefault(_diffusion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RaceDayLive = function RaceDayLive() {
	    var factory = this;
	
	    var templates = _templates2.default;
	    var local = {
	        data: [], // private array with raw data items
	        listKeys: [], // private array used to sort items
	        historyList: [], // private array for store data from history response
	        knownWarnings: {}, // topics that was handled by meeting filter function
	        inQueue: [] // private array for store data from diffusion LE response
	    };
	    var list = {}; // public collection of items, rendered and ready to display (or partially displayed yet)
	    var config = {
	        contentSelector: '#rdl-content',
	        messageNoPostsSelector: '.js-rdl-noPosts',
	        bottomSpinner: $(templates.buttons.footSpinner),
	        headerSpinner: $(templates.buttons.headSpinner),
	        headerNewButtonBox: $(templates.buttons.upload),
	        bottomStopElementSelector: '.ui-footer',
	        outerLinks: {
	            initial: 'https://events.racingpost.com/initial.sd?id=1',
	            history: 'https://events.racingpost.com/history.sd?id=1',
	            eventBody: 'https://events.racingpost.com/event_body.sd?id=',
	            eventHeader: 'https://events.racingpost.com/event_header.sd?id='
	        },
	        courseLink: '/racecards/',
	        links: { // mapper to meetings filter
	            0: 'betting',
	            5: 'latest',
	            26: 'quote',
	            20: 'mostTipped',
	            16: 'latest',
	            10: 'results',
	            19: 'backed',
	            11: 'hot',
	            12: 'hot',
	            13: 'hot',
	            82: 'comm'
	        },
	        linksKey: { // mapper to meetings filter aliases
	            0: 'betting',
	            'Q': 'quote',
	            'MT': 'mostTipped',
	            'LR': 'latest',
	            'CE': 'latest',
	            'MB': 'backed',
	            'HC': 'hot',
	            'HJ': 'hot',
	            'HT': 'hot',
	            'LC': 'comm',
	            'FRR': 'results'
	        },
	        imagesDomain: 'https://www.rp-assets.com',
	        assetsDomain: 'https://www.rp-assets.com',
	        currentFilter: '', // courses filter, integer
	        maximumTopicsInList: 9999999, // maximum number topics that can be showed (999999 cuz some problems with Number.MAX_SAFE_INTEGER)
	        buttonOnlyAtTop: false, // remove sticky function from button when scrolling
	        startRangeForTopics: 20, // initial number of posts to show
	        historyUpload: true, // load additional posts from history on scroll down
	        newUpload: true, // load new posts
	        updateRangeForOldTopics: 10, // +X posts every scroll down
	        adaptForExNarrowLayout: false, // at ex-wide breakpoint and ex-narrow container size ui has different displaying
	        filterCoursesFunction: function filterCoursesFunction(filter, data) {
	            data = typeof data.rawData !== 'undefined' ? data.rawData : data;
	            if (Object.keys(data).length === 0) {
	                console.log('Empty event response');
	                return false;
	            }
	            var courseId = typeof data.courseId !== 'undefined' ? parseInt(data.courseId, 10) : '';
	            return courseId !== 0 && (filter === '' || courseId === filter);
	        },
	        onInitCallback: function onInitCallback() {},
	        onUpdateCallback: function onUpdateCallback() {}
	    };
	
	    var init = function init(options) {
	        config = $.extend(config, options);
	        $('.rdl-content').attr('data-price-location', 'Raceday Live');
	        // Setting date for priceComponent
	        $(config.contentSelector).attr('data-diffusion-racedate', new Date().toISOString().substr(0, 10));
	        // Adding buttons and other
	        $(config.contentSelector).before(config.headerNewButtonBox).before(config.headerSpinner).after(config.bottomSpinner);
	        config.headerNewButton = $('.rdl-uploadBtn');
	
	        // handle other
	        handleFilterChange();
	        handleNewPostsBtnClick();
	        if (config.historyUpload) {
	            handleAutoUpload();
	        }
	
	        var hash = window.location.hash.replace('#', '');
	        if (hash !== 'meet0' && hash !== '') {
	            config.currentFilter = parseInt(hash.replace('meet', ''), 10);
	        }
	
	        config.headerSpinner.show();
	        setDataInitial(function () {
	            config.headerSpinner.hide();
	            showAll();
	            appendNoPostsMessage();
	            config.onInitCallback();
	            if (config.newUpload) {
	                initLive();
	            }
	        });
	
	        return this;
	    };
	
	    var initLive = function initLive() {
	        new _diffusion2.default($, {
	            topicName: 'LIVE_EVENT/1',
	            callbackLE: function callbackLE(id, type) {
	                addNewData({ id: id, type: type });
	                $.event.trigger('dynamicPricesUpdated.PRICES');
	            }
	        });
	    };
	
	    function handleFilterChange() {
	        $(window.document).on('filter.apply', function (event, filter) {
	            if (!filter) {
	                window.location.hash = '';
	            } else {
	                window.location.hash = 'meet' + filter;
	            }
	            setFilter(filter);
	            purge();
	            config.headerSpinner.show();
	            setDataInitial(function () {
	                sort();
	                config.headerSpinner.hide();
	                showAll(config.startRangeForTopics);
	                $.event.trigger('dynamicPricesUpdated.PRICES');
	            });
	            if (config.headerNewButtonBox.is(':visible')) {
	                goNewPosts();
	                event.stopPropagation();
	            }
	        });
	    }
	
	    function hideButton() {
	        config.headerNewButtonBox.removeClass('rdl-uploadBox-active');
	        config.headerNewButtonBox.removeClass('rdl-uploadBox-fixed');
	        $(config.contentSelector).css({ 'margin-top': 0 });
	    }
	
	    function goNewPosts() {
	        hideButton();
	        config.headerSpinner.show();
	        getTopicList(local.inQueue, getCountItems() + local.inQueue.length, function () {
	            renderAll(local.inQueue);
	            local.inQueue = [];
	            sort();
	            purge();
	            config.headerSpinner.hide();
	            showAll();
	            if ($(window).scrollTop() > $(config.contentSelector).offset().top + config.headerNewButtonBox.height()) {
	                $('body').animate({ scrollTop: $(config.contentSelector).offset().top }, 200);
	            }
	
	            $.event.trigger('dynamicPricesUpdated.PRICES');
	            config.onUpdateCallback();
	        });
	    }
	
	    function handleNewPostsBtnClick() {
	        config.headerNewButtonBox.width(config.headerNewButtonBox.parent().width());
	        config.headerNewButton.on('click', function () {
	            goNewPosts();
	        });
	    }
	
	    function handleAutoUpload() {
	        $(window).resize(function () {
	            config.headerNewButtonBox.width(config.headerNewButtonBox.parent().width());
	        });
	        $(window).scroll(function () {
	            if (checkVisible($(config.bottomStopElementSelector))) {
	                enhanceData();
	            }
	
	            changeButtonPosition();
	        });
	    }
	
	    function changeButtonPosition() {
	        $(config.contentSelector).css({ 'margin-top': 72 });
	        if (config.headerNewButtonBox.is(':visible')) {
	            if (!config.buttonOnlyAtTop) {
	                var isPositionFixed = config.headerNewButtonBox.hasClass('rdl-uploadBox-fixed');
	                var isButtonDeeperThanContent = $(config.contentSelector).outerHeight() + $(config.contentSelector).offset().top - $(window).scrollTop() <= 0;
	                if (!isPositionFixed && $(window).scrollTop() >= $(config.contentSelector).offset().top && !isButtonDeeperThanContent && !config.buttonOnlyAtTop) {
	                    config.headerNewButtonBox.removeClass('rdl-uploadBox-active');
	                    config.headerNewButtonBox.addClass('rdl-uploadBox-fixed');
	                }
	                if (isPositionFixed && ($(window).scrollTop() <= $(config.contentSelector).offset().top - config.headerNewButtonBox.outerHeight() || isButtonDeeperThanContent)) {
	                    config.headerNewButtonBox.removeClass('rdl-uploadBox-fixed');
	                    config.headerNewButtonBox.addClass('rdl-uploadBox-active');
	                }
	            }
	        } else {
	            hideButton();
	        }
	    }
	
	    var setDataInitial = function setDataInitial(callback) {
	        config.headerSpinner.show();
	        sort();
	        $.get(config.outerLinks.initial, function (data) {
	            data = JSON.parse(data);
	            renderAll(data);
	            var limit = Math.min(config.startRangeForTopics, config.maximumTopicsInList);
	            if (getCountItems() < limit && config.historyUpload) {
	                setDataHistory(callback, limit);
	            } else {
	                callback();
	            }
	        });
	
	        return this;
	    };
	
	    var setDataHistory = function setDataHistory(callback, limit) {
	        local.data = [];
	        sort();
	
	        // if there wan't change of filter, we don't need to renew history data, cuz local.data has all actual items
	        if (local.historyList.length === 0) {
	            $.get(config.outerLinks.history, function (items) {
	                items = items ? JSON.parse(items) : [];
	                local.historyList = Array.isArray(items) ? items : [];
	                getTopicList(items, limit, callback);
	            });
	        } else {
	            getTopicList(local.historyList, limit, callback);
	        }
	    };
	
	    var getTopicList = function getTopicList(historyItems, limit, callback) {
	        var deferred = [];
	
	        // creating array of deferred objects (events)
	        var getDeferred = function getDeferred(item) {
	            return $.get(config.outerLinks.eventHeader + item.i, function (data) {
	                local.data.push(JSON.parse(data));
	            });
	        };
	
	        // cycle of adding to deferred object pull
	        for (var item, i = 0, j = getCountItems(), to = historyItems.length; i < to && j < limit; i++) {
	            if (filterMeetingsFunction(historyItems[i]) && typeof list[historyItems[i].i] === 'undefined') {
	                j++;
	                if (typeof historyItems[i].eventId !== 'undefined') {
	                    local.data.push(historyItems[i]);
	                } else {
	                    deferred.push(getDeferred(historyItems[i]));
	                }
	            }
	        }
	
	        if (deferred.length > 0) {
	            // after resolving all deferred objects we can work with them
	            $.when.apply($, deferred).always(function () {
	                renderAll();
	                callback();
	            });
	        } else {
	            callback();
	        }
	    };
	
	    var enhanceData = function enhanceData() {
	        if (getCountItems() < config.maximumTopicsInList) {
	            config.bottomSpinner.show();
	
	            var limit = Math.min(getCountItems() + config.updateRangeForOldTopics, config.maximumTopicsInList);
	            setDataHistory(function () {
	                sort();
	                config.bottomSpinner.hide();
	                showAll(limit);
	                $.event.trigger('dynamicPricesUpdated.PRICES');
	            }, limit);
	        }
	    };
	
	    var getCountItems = function getCountItems() {
	        var total = 0;
	
	        for (var i = 0; i < local.listKeys.length; i++) {
	            if (config.filterCoursesFunction(config.currentFilter, list[local.listKeys[i]])) {
	                total++;
	            }
	        }
	        return total;
	    };
	
	    var setFilter = function setFilter(filter) {
	        config.currentFilter = filter ? parseInt(filter, 10) : '';
	    };
	
	    /**
	     * Generates url to race card.
	     *
	     * @example https://www.racingpost.com/racecards/1083/chelmsford-aw/2016-12-19/664011
	     *
	     * @param id
	     * @param name
	     * @param date
	     * @param rid
	     * @returns {string}
	     */
	    var generateRaceCardUrl = function generateRaceCardUrl(id, name, date, rid) {
	        return config.courseLink + id + '/' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-') + '/' + date + '/' + rid;
	    };
	
	    /**
	     * This method generates link to page where single course shown: list of race cards.
	     *
	     * @example https://www.racingpost.com/racecards/1083/chelmsford-aw/2016-12-19
	     *
	     * @param id
	     * @param name
	     * @param date
	     * @param rid
	     * @returns {string}
	     */
	    var generateCourseUrlBigScreen = function generateCourseUrlBigScreen(id, name, date, rid) {
	        if (rid) {
	            return generateRaceCardUrl(id, name, date, rid);
	        }
	        return config.courseLink + id + '/' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-') + '/' + date;
	    };
	
	    /**
	     * This method generates link to page where list of courses shown: list of courses with correspondent race cards.
	     *
	     * @example https://www.racingpost.com/racecards/#chelmsford-aw
	     *
	     * @param id
	     * @param name
	     * @param date
	     * @param rid
	     * @returns {string}
	     */
	    var generateCourseUrlSmallScreen = function generateCourseUrlSmallScreen(id, name, date, rid) {
	        if (rid) {
	            return generateRaceCardUrl(id, name, date, rid);
	        }
	        return config.courseLink + '#' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-');
	    };
	
	    var getTopicRendered = function getTopicRendered(id) {
	        var isExist = false;
	        for (var i = 0, to = local.listKeys.length; i < to; i++) {
	            if (parseInt(local.listKeys[i], 10) === parseInt(id, 10)) {
	                isExist = list[id];
	                break;
	            }
	        }
	        return isExist;
	    };
	
	    function addNewData(data) {
	        data = { i: parseInt(data.id, 10), t: data.type };
	
	        if (!data.i) {
	            return false;
	        }
	
	        $.get(config.outerLinks.eventHeader + data.i).success(function (result) {
	            result = JSON.parse(result);
	            var existItem;
	            if (existItem = getTopicRendered(result.eventId)) {
	                existItem.renew(result);
	                $.event.trigger('dynamicPricesUpdated.PRICES');
	            } else {
	                var newQueue = findNotShownPost(local.inQueue, data.i);
	                var historyQueue = findNotShownPost(local.historyList, data.i);
	                if (newQueue && newQueue >= 0) {
	                    local.inQueue[newQueue] = result;
	                    $.event.trigger('dynamicPricesUpdated.PRICES');
	                } else if (historyQueue && historyQueue >= 0) {
	                    //just ignore cuz any data about it is not loaded
	                } else if (config.filterCoursesFunction(config.currentFilter, result)) {
	                    local.historyList.unshift(data);
	                    local.inQueue.unshift(result);
	
	                    $(config.messageNoPostsSelector).hide();
	                    config.headerNewButtonBox.addClass('rdl-uploadBox-active');
	
	                    changeButtonPosition();
	                }
	            }
	        });
	
	        return true;
	    }
	
	    function findNotShownPost(array, desiredValue) {
	        var predicate = function predicate(arrayItem) {
	            return arrayItem.i === desiredValue;
	        };
	        return array.findIndex(predicate);
	    }
	
	    function purge() {
	        $(config.contentSelector).empty();
	    }
	
	    function sort() {
	        local.listKeys.sort(function (a, b) {
	            var timeB = list[b].rawData.releaseTime || list[b].rawData.postedAt * 1000;
	            var timeA = list[a].rawData.releaseTime || list[a].rawData.postedAt * 1000;
	            return parseInt(timeB, 10) - parseInt(timeA, 10);
	        });
	
	        return factory;
	    }
	
	    function filterMeetingsFunction(data) {
	        if (Object.keys(data).length == 0) {
	            // Skipping empty Event
	            return false;
	        }
	
	        data = typeof data.rawData !== 'undefined' ? data.rawData : data;
	        var key = data.t ? data.t : typeof data.typeKey !== 'undefined' ? data.typeKey : false;
	        var result = key && typeof config.linksKey[key] !== 'undefined';
	        if (!result && typeof local.knownWarnings[key] === 'undefined') {
	            local.knownWarnings[key] = [];
	            console.log('Unknown Type of Event: ' + key + '. JSON Item: ', data);
	        }
	        if (!result) {
	            local.knownWarnings[key].push(data);
	        }
	        return result;
	    }
	
	    function showAll(limit, filterCoursesFunction) {
	        filterCoursesFunction = filterCoursesFunction || config.filterCoursesFunction;
	        if (!limit) {
	            limit = 9999999;
	        }
	        limit = Math.min(limit, local.listKeys.length, config.maximumTopicsInList);
	
	        for (var i = 0, cur = 0; cur < limit && i < local.listKeys.length; i++) {
	            if (filterCoursesFunction(config.currentFilter, list[local.listKeys[i]]) && !list[local.listKeys[i]].$html.is(':visible')) {
	                list[local.listKeys[i]].apply();
	                cur++;
	            }
	        }
	        return factory;
	    }
	
	    function appendNoPostsMessage(to) {
	        var $html = $(templates.messages.noPosts).clone().hide();
	        $html.appendTo(to || $(config.contentSelector));
	        if (config.adaptForExNarrowLayout) {
	            $html.addClass('rdl-narrowContainer');
	        }
	
	        if (local.listKeys.length === 0) {
	            $html.show();
	        }
	    }
	
	    function renderAll(data) {
	        data = data || local.data;
	
	        var item;
	
	        for (var i = 0, to = data.length; i < to; i++) {
	            // only if we have no that rendered item
	            // and it satisfies Meeting filters
	            if (typeof list[data[i].eventId] === 'undefined' && filterMeetingsFunction(data[i])) {
	                item = create(data[i]);
	                if (item !== null) {
	                    list[item.id] = item.render();
	                    if (local.listKeys.indexOf(item.id) === -1) {
	                        local.listKeys.push(item.id);
	                    }
	                }
	            }
	        }
	        return factory;
	    }
	
	    // helper function to check visibility of element
	    function checkVisible(elm) {
	        var vpH = $(window).height(),
	            st = $(window).scrollTop(),
	            y = $(elm).offset().top,
	            h = $(elm).height();
	        return y + h > st && y < vpH + st;
	    }
	
	    // helper function that return pretty time format from current moment
	    /*
	    * @param date - date of event
	    * @param currentDate - date which can be set as current (for testing mainly)
	    * Helper function that return pretty time format from current moment
	    */
	    var timeSince = function timeSince(date, currentDate) {
	        currentDate = currentDate || new Date();
	        var seconds = Math.floor((currentDate - date) / 1000);
	        var interval = Math.floor(seconds / 31536000);
	
	        if (interval >= 1) {
	            return interval + ' year' + (interval > 1 ? 's' : '');
	        }
	        interval = Math.floor(seconds / 2592000);
	        if (interval >= 1) {
	            return interval + ' month' + (interval > 1 ? 's' : '');
	        }
	        interval = Math.floor(seconds / 86400);
	        if (interval >= 1) {
	            return interval + ' day' + (interval > 1 ? 's' : '');
	        }
	        interval = Math.floor(seconds / 3600);
	        if (interval >= 1) {
	            return interval + ' hour' + (interval > 1 ? 's' : '');
	        }
	        interval = Math.floor(seconds / 60);
	        if (interval >= 1) {
	            return interval + ' minute' + (interval > 1 ? 's' : '');
	        }
	        return Math.floor(seconds) + ' second' + (Math.floor(seconds) > 1 ? 's' : '');
	    };
	
	    var create = function create(element) {
	        var name = 'create' + config.linksKey[element.typeKey].charAt(0).toUpperCase() + config.linksKey[element.typeKey].slice(1);
	        return createMethods[name](element);
	    };
	
	    var ModelProto = function ModelProto(data, selector) {
	        var id = data.eventId || null;
	        var $html = $(templates.patterns[selector]).clone();
	        var time = timeSince(data.releaseTime || data.postedAt * 1000) + ' ago';
	        var canCreateLink = data.courseId && data.courseName;
	        var now = new Date();
	        var date = data.raceDate || now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
	
	        if (id !== null) {
	            $html.attr('id', 'rdl-id-' + id);
	        }
	        $html.find('.js-rdl-time').html((data.byline ? data.byline + ' - ' : '') + time);
	
	        var ret = {
	            id: id,
	            updated: false,
	            $html: $html,
	            rawData: data,
	            time: time,
	            by: data.byline || '',
	            header: data.header || '',
	            ico: data.image || '',
	            body: data.story || data.synopsis || '',
	            outerLinkTitle: canCreateLink ? (data.raceTime ? data.raceTime + ' ' : '') + data.courseName : '',
	            outerLinkUrlBigScreen: canCreateLink ? generateCourseUrlBigScreen(data.courseId, data.courseName, date, data.raceId) : '', // link to single course
	            outerLinkUrlSmallScreen: canCreateLink ? generateCourseUrlSmallScreen(data.courseId, data.courseName, date, data.raceId) : '', // link to list of courses
	            betTitle: data.horseName || '',
	            betBody: ((data.raceTime || '') + ' ' + (data.courseName || '')).trim(),
	            buttons: [],
	
	            // in question of
	            namesWithComments: data.commentList || [],
	
	            apply: function apply(to) {
	                this.$html.appendTo(to || $(config.contentSelector));
	                return this;
	            },
	            renew: function renew(data) {
	                var newItem = create(data);
	                newItem.render();
	                $.extend(this, newItem);
	                $('#rdl-id-' + this.id).replaceWith(newItem.$html);
	
	                return this;
	            },
	            appendButtons: function appendButtons() {
	                if (typeof this.rawData.inlinePrice !== 'undefined') {
	                    var $html = this.$html;
	                    this.buttons.forEach(function (btn) {
	                        btn.appendTo($html.find('.rdl-itemContent'));
	                    });
	                    $html.find('.rdl-itemContent').addClass('js-PC-runnerRow');
	                }
	            }
	        };
	
	        setInterval(function () {
	            ret.time = timeSince(data.releaseTime || data.postedAt * 1000) + ' ago';
	            $html.find('.js-rdl-time').html((data.byline ? data.byline + ' - ' : '') + ret.time);
	        }, 60000);
	
	        return ret;
	    };
	
	    var createMethods = {
	        parentConfig: config,
	
	        createButtons: function createButtons(data) {
	            if (typeof data.rawData.inlinePrice !== 'undefined') {
	                if (data.rawData.inlinePrice.length > 0) {
	                    for (var i = 0, count = data.rawData.inlinePrice.length; i < count; i++) {
	                        if (data.rawData.inlinePrice[i].hasOwnProperty("diffusionCourseName")) {
	                            data.buttons.push(createMethods.createButton(data, i));
	                        }
	                    }
	                }
	            }
	            return data;
	        },
	
	        createButton: function createButton(data, inlinePriceIterator) {
	            var $html = $(templates.patterns['button']).clone();
	
	            function toTitleCase(str) {
	                var pstr = str.replace(/\w\S*/g, function (txt) {
	                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	                });
	                return $('<div/>').html(pstr).text();
	            }
	
	            var actualData = data.rawData.inlinePrice[inlinePriceIterator];
	
	            $html.attr('data-diffusion-coursename', actualData.diffusionCourseName).attr('data-diffusion-racetime', actualData.raceTime24).attr('data-diffusion-racedate', actualData.raceDate).attr('data-card-race-date-time', actualData.raceDate + 'T' + actualData.raceTime24 + ':00+01:00').attr('data-diffusion-horsename', toTitleCase(actualData.horseName.replace('&acute;', '&#039;'))) // replace ` with ' for priceConnector
	            .attr('data-diffusion-race-id', actualData.raceId).addClass('js-diffusionHorsesList');
	
	            $html.find('.rdl-addComm-title').html(actualData.horseName || '');
	            $html.find('.rdl-addComm-body').html(actualData.raceTime ? actualData.raceTime + ' ' + actualData.courseName : '');
	
	            return $html;
	        },
	
	        createQuote: function createQuote(data) {
	            var selector = 'quote';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    return this;
	                }
	            });
	        },
	
	        createMostTipped: function createMostTipped(data) {
	            var selector = 'mostTipped';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    return this;
	                }
	            });
	        },
	
	        createLatest: function createLatest(data) {
	            var selector = 'latest';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                localConfig: this.parentConfig,
	                render: function render() {
	                    // For images of reporters  the Alt and the Title to be the name of the reporter (NEWS-1679)
	                    var alt = this.by.replace('By ', '');
	
	                    /*
	                     * Change images domain as required in
	                     * https://racingpost.atlassian.net/browse/NEWS-2071
	                     */
	                    this.ico = this.ico.replace(this.localConfig.imagesDomain, this.localConfig.assetsDomain);
	                    this.$html.find('.rdl-ico').attr('src', this.ico).attr('alt', alt).attr('title', alt);
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    if (this.outerLinkTitle !== '') {
	                        // Link to page with list of courses
	                        this.$html.find('.js-outerLink-hidden-md-up').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlSmallScreen);
	                        // Link to page with single course
	                        this.$html.find('.js-outerLink-hidden-sm-down').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlBigScreen);
	                    } else {
	                        this.$html.find('.rdl-outerLink').hide();
	                    }
	
	                    return this;
	                }
	            });
	        },
	
	        createResults: function createResults(data) {
	            var selector = 'results';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    if (this.outerLinkTitle !== '') {
	                        this.$html.find('.rdl-outerLink').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlBigScreen);
	                    } else {
	                        this.$html.find('.rdl-outerLink').hide();
	                    }
	
	                    return this;
	                }
	            });
	        },
	
	        createBacked: function createBacked(data) {
	            var selector = 'backed';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    return this;
	                }
	            });
	        },
	
	        createBetting: function createBetting(data) {
	            var selector = 'betting';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    return this;
	                }
	            });
	        },
	
	        createHot: function createHot(data) {
	            var selector = 'hot';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    this.$html.find('.js-rdl-itemTitle').html(this.header);
	                    this.$html.find('.js-rdl-body').html(this.body);
	
	                    createMethods.createButtons(this).appendButtons();
	
	                    return this;
	                }
	            });
	        },
	
	        createComm: function createComm(data) {
	            var selector = 'comm';
	            var initData = new ModelProto(data, selector);
	
	            return $.extend(initData, {
	                render: function render() {
	                    var $to = this.$html.find('.rdl-post__body');
	                    var $cloned = $to.find('.rdl-itemBodyList');
	                    $to.empty();
	                    for (var i = 0; i < this.namesWithComments.length; i++) {
	                        var $copy = $cloned.clone();
	                        $copy.find('.js-rdl-body').html(this.namesWithComments[i].body);
	                        $to.append($copy);
	                    }
	                    $cloned.remove();
	
	                    return this;
	                }
	            });
	        }
	    };
	
	    return {
	        purge: purge,
	        sort: sort,
	        showAll: showAll,
	        list: list,
	        init: init,
	        setDataInitial: setDataInitial,
	        setDataHistory: setDataHistory,
	        config: config,
	        setFilter: setFilter,
	        enhanceData: enhanceData,
	        addNewData: addNewData,
	        changeButtonPosition: changeButtonPosition,
	        // return this method for testing purposes
	        _createMethods: createMethods,
	        _timeSince: timeSince
	    };
	};
	
	exports.RaceDayLive = RaceDayLive;
	exports.RdlTemplates = _templates2.default;
	exports.RdlDiffusion = _diffusion2.default;

/***/ }),

/***/ 1532:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	window.rp1 = window.rp1 || {};
	window.rp1.assetsUrl = window.rp1.assetsUrl || $('body').data('assets-url') || '';
	
	var RdlTemplates = {
	    messages: {
	        noPosts: '<div class="js-rdl-noPosts ui-errorMessage"><div class="ui-errorMessage__icon"><svg class="ui-icon ui-icon_sizeXL rdl-icon-lifeNews"><use xlink:href="#icon-lifeNews"/></svg></div><div class="ui-errorMessage__text">Raceday Live returns later this morning from 7am</div></div>'
	    },
	    patterns: {
	        quote: '<section class="rdl-section rdl-quote"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-quote"><use xlink:href="#icon-comment"/></svg></div><h2 class="rdl-postType">Quote to Note</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="rdl-post__body"><span class="js-rdl-body"></span></div></div></section>',
	        mostTipped: '<section class="rdl-section rdl-mostTipped"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-mostTipped"><use xlink:href="#icon-tick"/></svg></div><h2 class="rdl-postType">Most Tipped</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="js-rdl-body rdl-post__body"></div></div></section>',
	        latest: '<section class="rdl-section rdl-latest"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><img class="rdl-ico rdl-icon-latest" src=""/></div><h2 class="rdl-postType">Latest</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="js-rdl-body rdl-post__body"></div><a class="js-outerLink-hidden-sm-down hidden-sm-down rdl-outerLink rdl-links ui-link ui-link_table" href=""><svg class="ui-icon ui-icon__btn rdl-icon-link ui-icon_smallChevron"><use xlink:href="#icon-right"/></svg></a><a class="js-outerLink-hidden-md-up hidden-md-up rdl-outerLink rdl-links ui-link ui-link_table" href=""><svg class="ui-icon ui-icon_smallChevron rdl-icon-link"><use xlink:href="#icon-right"/></svg></a></div></section>',
	        results: '<section class="rdl-section rdl-results"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-results"><use xlink:href="#icon-results"/></svg></div><h2 class="rdl-postType">Results</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="rdl-post__body"><span class="js-rdl-body"></span></div><a class="rdl-outerLink rdl-links ui-link ui-link_table" href=""><svg class="ui-icon ui-icon_smallChevron rdl-icon-link"><use xlink:href="#icon-right"/></svg></a></div></section>',
	        backed: '<section class="rdl-section rdl-backed"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-backed"><use xlink:href="#icon-starFilled"/></svg></div><h2 class="rdl-postType">Most Backed</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div></div></section>',
	        betting: '<section class="rdl-section rdl-betting"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-betting"><use xlink:href="#icon-betSlip"/></svg></div><h2 class="rdl-postType">Betting</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="js-rdl-body rdl-post__body"></div></div></section>',
	        hot: '<section class="rdl-section rdl-hot"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-hot"><use xlink:href="#icon-hot"/></svg></div><h2 class="rdl-postType">Hot</h2><div class="rdl-itemContent rdl-post"><div class="js-rdl-itemTitle rdl-post__headline"></div><div class="js-rdl-body rdl-post__body"></div></div></section>',
	        comm: '<section class="rdl-section rdl-commentary"><div class="js-rdl-time rdl-timestamp"></div><div class="rdl-icon"><svg class="ui-icon ui-icon_sizeLarge rdl-icon-commentary"><use xlink:href="#icon-liveCommentary"/></svg></div><h2 class="rdl-postType">Commentary</h2><div class="rdl-itemContent rdl-post"><div class="rdl-post__headline"></div><div class="rdl-post__body"><div class="rdl-itemBodyList"><span class="js-rdl-body"></span></div></div></div></section>',
	        button: '<div class="rdl-button rdl-betBlock" data-card-race-date-time="" data-diffusion-coursename="" data-diffusion-racedate="" data-diffusion-racetime="" data-diffusion-horsename="" data-diffusion-bookmaker=""><div class="PC-bestOddsContainer js-bestOddsPriceContainer"><button class="betBtn rdl-itemButton ui-btn ui-priceBtn_noPrice js-diffusionPriceValue js-betHandler js-runnerPrice js-runnerPriceBestOdds"></button></div><div class="rdl-addComm rdl-betComment"><div class="rdl-addComm-title rdl-betComment__title"></div><div class="rdl-addComm-body"></div></div></div>'
	    },
	    buttons: {
	        upload: '<div class="rdl-uploadBox"><div class="ui-btn ui-btn_primary rdl-uploadBtn"><svg class="ui-icon ui-icon_size2XL rdl-uploadBtn-showIcon" viewBox="0 0 16 16"><path fill="#FFF" fill-rule="evenodd" d="M6.65.008A.48.48 0 0 1 7 .16l2.74 2.77a.48.48 0 0 1 0 .7L6.96 6.39a.48.48 0 0 1-.7 0 .48.48 0 0 1 0-.7l2-2H8a5.65 5.65 0 1 0 5.37 7.5.48.48 0 0 1 .63-.3.5.5 0 0 1 .28.64A6.65 6.65 0 1 1 8 2.7h.1L6.3.87a.5.5 0 0 1 0-.71.48.48 0 0 1 .35-.152zm7.36 7.942a.505.505 0 0 1 .57.43 6.2 6.2 0 0 1 .03.96v.48a.5.5 0 0 1-.5.47l-.08-.01a.5.5 0 0 1-.39-.53v-.41c0-.274-.02-.549-.06-.82a.505.505 0 0 1 .43-.57zm-.65-1.58a.5.5 0 0 1 .67.24c.05.12.16.25.16.38a.51.51 0 0 1-.28.65.58.58 0 0 1-.19 0 .49.49 0 0 1-.46-.32c-.04-.11-.09-.21-.14-.32a.49.49 0 0 1 .24-.63zm-1.07-1.5a.503.503 0 0 1 .71.04l.12.19a.49.49 0 0 1-.07.7.49.49 0 0 1-.7-.06l-.1-.16a.503.503 0 0 1 .04-.71z"/></svg>New posts are available</div></div>',
	        headSpinner: '<div class="rdl-spinner"><svg class="ui-icon ui-icon_size2XL rdl-icon-spinner ui-animation_spinnerAnimation"><use xlink:href="#icon-spinner"/></svg></div>',
	        footSpinner: '<div class="rdl-spinner"><svg class="ui-icon ui-icon_size2XL rdl-icon-spinner ui-animation_spinnerAnimation"><use xlink:href="#icon-spinner"/></svg></div>'
	    }
	};
	
	exports.default = RdlTemplates;

/***/ })

});


// WEBPACK FOOTER //
// app.min.js